/* Ardor DTF Transfer Designer: DTF transfers (direct-to-film, the customer presses them onto their own shirts) on a
22 in wide sheet, 3 to 120 in long. Two ways to lay out: one design x copies (the copies are placed for you, 1/4 in apart and
1/8 in from every edge, on the cheapest sheet length and sheet count) or a gang sheet (many designs placed freely, "Fit sheet
to designs"). Upload, background removal, resolution / fine detail / margin checks, text, clipart and AI designs, a 2D
t-shirt preview at true size (12 shirt colors, placement presets) and a 3D shirt (assets/ardor-dtf3d.js when present),
live price from the product's Size x Quantity tier variants, proof approval, print files (transparent PNG at 300 dpi at the
exact sheet size, made in bands, plus a PDF copy) uploaded to cloud storage, cart and quote. Ardor Printing. New Oct 14, 2026.
Made by the patch list dtf/core/builder.patch from a copy of assets/ardor-flag-builder-v2.js (unchanged): the messages,
proof approval and signature, quote dialog and sticky header code are the flag designer's; the rest is new.
Loaded by sections/ardor-dtf-builder-ws.liquid after ardor-dtf-engine.js and ardor-dtf-shirt.js. Works with
ardor-dtf-layers.js (designs, text and clipart on the sheet; Fabric.js), ardor-dtf-ai.js (AI design), ardor-dtf3d.js
(3D shirt), ardor-dtf-tpl.js (template download), assets/ardor-proofsheet.js (proof PDF) and ardor-dtf-upload.js
(print files to cloud storage). */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  if (!Array.isArray(CONF.variants)) CONF.variants = [];
  var PHONE = CONF.phone || '(425) 629-0796';

  // ---------- sheet sizes, quantity tiers and prices ----------
  // One Shopify variant per sheet length and quantity tier (product "Custom DTF Transfers", 118 lengths x 7 tiers). The
  // section writes every variant into the config: k = SKU ("DTF-22x<L>-Q<tier min>", any letter case), o1 / o2 = option
  // values (Size "22 x <L> in", Quantity "1 sheet" ... "50-100 sheets"), id, c = price of ONE sheet in cents for that tier,
  // a = available. The cart line quantity is the number of sheets. FALLBACK (window.ArdorDtfSpecs.fallback, cents per
  // length and tier) is only used when the config has no variants, so a price always shows; Add to cart then asks the
  // customer to call.
  var E = window.ArdorDtfEngine, SH = window.ArdorDtfShirt, SPECS = window.ArdorDtfSpecs || {};
  var SHEET_W = 22, MARGIN = 0.125, GAP = 0.25, LMIN = 3, LMAX = 120, PPI = 300;
  var MAX_QTY = 100, MAX_COPIES = 10000, MAX_FILE = 60 * 1024 * 1024;
  var TIERS = [1, 2, 3, 5, 10, 25, 50];
  var TIER_TXT = { 1: '1 sheet', 2: '2 sheets', 3: '3-4 sheets', 5: '5-9 sheets', 10: '10-24 sheets', 25: '25-49 sheets', 50: '50-100 sheets' };
  var PICKUP = CONF.pickup || '12531 Old Snohomish Monroe Rd., Snohomish, WA 98290';
  var LEN_CHIPS = [12, 24, 36, 48, 60, 84, 120];
  var PRESS = SPECS.press || 'Press at 290-320 F with medium to firm pressure (35-50 PSI) for 10-20 seconds. Pre-press the shirt for 5-7 seconds first. Let the transfer cool all the way, then peel the film (cold peel). Cover with a teflon sheet and press again for 5-7 seconds.';
  function tierOf(q) { var t = 1; TIERS.forEach(function (x) { if (q >= x) t = x; }); return t; }
  function tierName(q) { return TIER_TXT[tierOf(q)]; }
  function parseSku(k) {
    var m = /^DTF-22X(\d{1,3})(?:-Q?(\d{1,3}))?$/i.exec(String(k || '').trim());
    if (!m) return null;
    var L = +m[1], t = m[2] ? +m[2] : 1;
    return L >= LMIN && L <= LMAX && TIERS.indexOf(t) >= 0 ? { L: L, t: t } : null;
  }
  function fromOptions(v) {
    var o = [v.o1, v.o2, v.o3].map(function (x) { return String(x == null ? '' : x); }), L = 0, t = 0;
    o.forEach(function (s) {
      var a = /22\s*(?:in|")?\s*[x×]\s*(\d{1,3})/i.exec(s);
      if (a && !L) { L = +a[1]; return; }
      var b = /^\s*(\d{1,3})/.exec(s);
      if (b && !t && /sheet|qty|quantity|^\s*\d/i.test(s)) t = tierOf(+b[1]);
    });
    return L >= LMIN && L <= LMAX ? { L: L, t: t || 1 } : null;
  }
  var VAR = {}, LIVE = false;
  CONF.variants.forEach(function (v) {
    if (!v) return;
    var p = parseSku(v.k) || fromOptions(v);
    if (!p) return;
    var cents = Math.round(Number(v.c));
    VAR[p.L + '|' + p.t] = { id: v.id || null, cents: isFinite(cents) && cents > 0 ? cents : 0, available: v.a !== false, sku: String(v.k || ''), L: p.L, t: p.t };
    LIVE = true;
  });
  // Liquid lists only a product's first 250 variants (Shopify's cap). The rest of the 826 come from the storefront at
  // start: Shopify's tokenless Storefront API, else the product's .js. Prices update when they arrive.
  var moreP = null;
  function addVariant(id, sku, cents, avail, o1, o2) {
    var p = parseSku(sku) || fromOptions({ o1: o1, o2: o2 }); if (!p || !id) return;
    var k = p.L + '|' + p.t; if (VAR[k] && VAR[k].id) return;
    cents = Math.round(Number(cents));
    VAR[k] = { id: id, cents: isFinite(cents) && cents > 0 ? cents : 0, available: avail !== false, sku: String(sku || ''), L: p.L, t: p.t };
    LIVE = true;
  }
  function loadMoreVariants() {
    var want = +CONF.variantCount || 0, have = Object.keys(VAR).length;
    // Liquid listed fewer than 250: that is all of them. 250 or more: the product may have more (Liquid's cap)
    if (!CONF.productHandle || (CONF.variants.length < 250 && (!want || have >= want))) return Promise.resolve(false);
    if (moreP) return moreP;
    var q = 'query DtfVariants($h: String!, $a: String) { product(handle: $h) { variants(first: 250, after: $a) { nodes { id sku availableForSale price { amount } selectedOptions { name value } } pageInfo { hasNextPage endCursor } } } }';
    var page = function (after, n) {
      return fetch('/api/2025-07/graphql.json', { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ query: q, variables: { h: CONF.productHandle, a: after || null } }) })
        .then(function (r) { if (!r.ok) throw new Error('storefront api ' + r.status); return r.json(); })
        .then(function (j) {
          var v = j && j.data && j.data.product && j.data.product.variants;
          if (!v) throw new Error('storefront api');
          v.nodes.forEach(function (x) {
            var so = x.selectedOptions || [], o1 = so[0] ? so[0].value : '', o2 = so[1] ? so[1].value : '';
            addVariant(+String(x.id).split('/').pop(), x.sku, Math.round(parseFloat(x.price && x.price.amount) * 100), x.availableForSale !== false, o1, o2);
          });
          if (v.pageInfo && v.pageInfo.hasNextPage && n < 8) return page(v.pageInfo.endCursor, n + 1);
        });
    };
    var ajax = function () {
      return fetch('/products/' + encodeURIComponent(CONF.productHandle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product js'); return r.json(); })
        .then(function (pr) { (pr.variants || []).forEach(function (x) { addVariant(x.id, x.sku, x.price, x.available !== false, x.option1, x.option2); }); });
    };
    moreP = page(null, 0).then(function () { if (want > 250 && Object.keys(VAR).length < want) return ajax(); }).catch(ajax).catch(function () {}).then(function () { render(); return Object.keys(VAR).length; });
    return moreP;
  }
  function fallbackCents(L, t) { var f = (SPECS.fallback || {})[L]; if (!f) return 0; return Math.round(+f[TIERS.indexOf(t)] || 0); }
  // the variant for a sheet length and a number of sheets (its quantity tier). none = not sold
  function variantFor(L, q) {
    var t = tierOf(q), v = VAR[L + '|' + t];
    if (v) return v;
    if (LIVE) return { id: null, cents: 0, available: false, none: true, L: L, t: t };
    var x = fallbackCents(L, t);
    return { id: null, cents: x, available: false, none: !x, L: L, t: t };
  }
  // price of one sheet in cents (0 = can't be ordered online)
  function centsFor(L, q) { var v = variantFor(L, q); return v.none || (LIVE && !v.available) ? 0 : v.cents; }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { return String(Math.round(n * 100) / 100); }
  function fmt1(n) { return String(Math.round(n * 10) / 10); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : (many || one + 's')); }

  // ---------- the designs on the sheet (Fabric objects in sheet inches, kept by ardor-dtf-layers.js) ----------
  // IMGS: every uploaded or AI picture, by id. el = what the editor shows (the full picture, or a smaller copy of a very big
  // one); bgRemoved = the background removal that was done (orig keeps the picture before it, for Undo).
  var IMGS = {}, imgSeq = 0;
  function LY() { return window.ArdorDtfLayers || null; }
  function FC() { var l = LY(); return l && l.canvas ? l.canvas() : null; }
  function objs() { var fc = FC(); return fc ? fc.getObjects().filter(function (o) { return o.visible !== false && o.ablKind !== 'cover'; }) : []; }
  function boxOf(o) { var r = o.getBoundingRect(true, true); return { x: r.left, y: r.top, w: r.width, h: r.height }; }
  function unionBox(bs) {
    if (!bs.length) return null;
    var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
    bs.forEach(function (b) { x0 = Math.min(x0, b.x); y0 = Math.min(y0, b.y); x1 = Math.max(x1, b.x + b.w); y1 = Math.max(y1, b.y + b.h); });
    return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
  }
  function masterBox() { return unionBox(objs().map(boxOf)); }
  function kindOf(o) { return o ? (o.ablKind || (/text/.test(o.type) ? 'text' : (o.type === 'image' ? 'image' : 'clipart'))) : ''; }
  function entryOf(o) { return o && o.ablSrc ? IMGS[o.ablSrc] || null : null; }
  function objName(o) {
    var k = kindOf(o), en = entryOf(o);
    if (k === 'text') return 'Text "' + String(o.text || '').replace(/\s+/g, ' ').slice(0, 40) + '"';
    if (k === 'image') return en ? en.name : (o.ablLabel || 'Image');
    return o.ablLabel || 'Clipart';
  }
  // print resolution of a picture at its size on the sheet (Infinity for vector files)
  function dpiOf(o) {
    var en = entryOf(o); if (!en || en.vector) return Infinity;
    var w = o.getScaledWidth(), h = o.getScaledHeight();
    return Math.min(en.srcW / Math.max(w, 1e-6), en.srcH / Math.max(h, 1e-6));
  }

  var S = { mode: 'simple', len: 12, copies: 10, sheets: 1, delivery: 'ship', shirt: 'black', view: 'front', size: 'adult', place: 'front', show: '2d', artVer: 0, lenTouched: false };
  (function () {
    var m = String(CONF.defaultMode || '').toLowerCase(); if (m === 'gang') S.mode = 'gang';
    var L = Math.round(num(CONF.defaultLength, 12)); S.len = clamp(L, LMIN, LMAX);
  })();

  // c.Wi x c.Hi = the sheet in inches (22 x L). One design: c.box = the design (all objects together), c.plan = the
  // cheapest length and sheet count for the copies. Gang sheet: the length and sheets the customer picked.
  function cfg() {
    var c = { mode: S.mode, delivery: S.delivery === 'pickup' ? 'pickup' : 'ship', artVer: S.artVer };
    var list = objs();
    c.count = list.length;
    if (S.mode === 'simple') {
      c.copies = clamp(Math.round(num(S.copies, 1)), 1, MAX_COPIES);
      c.box = masterBox();
      // copies may be turned 90 degrees on the sheet when that is cheaper (they are cut apart and pressed upright)
      var pu = c.box && E ? E.plan(c.box.w, c.box.h, c.copies, centsFor) : null, pr = null;
      if (c.box && E && Math.abs(c.box.w - c.box.h) > 0.01) pr = E.plan(c.box.h, c.box.w, c.copies, centsFor);
      var better = !!(pr && pr.ok && (!pu || !pu.ok || pr.total < pu.total));
      c.turnSaves = better && pu && pu.ok ? (pu.total - pr.total) / 100 : 0;
      c.turn = better && !S.noTurn;
      c.plan = c.turn ? pr : pu;
      if (c.plan && c.plan.ok) { c.len = c.plan.len; c.qty = c.plan.sheets; c.per = c.plan.per; }
      else { c.len = c.box ? clamp(Math.ceil(c.box.h + 2 * MARGIN), LMIN, LMAX) : S.len; c.qty = 1; c.per = 1; }
      c.sw = c.box ? (c.turn ? c.box.h : c.box.w) : 0; c.sh = c.box ? (c.turn ? c.box.w : c.box.h) : 0;
      c.layout = c.box && E ? E.pack(c.sw, c.sh, c.per, c.len) : null;
    } else {
      c.len = clamp(Math.round(num(S.len, 12)), LMIN, LMAX);
      c.qty = clamp(Math.round(num(S.sheets, 1)), 1, MAX_QTY);
      c.box = unionBox(list.map(boxOf));
    }
    c.Wi = SHEET_W; c.Hi = c.len;
    c.v = variantFor(c.len, c.qty);
    return c;
  }
  // each = one sheet; charged = what goes in the cart
  function price(c) {
    var each = (c.v.none ? 0 : c.v.cents) / 100;
    return { each: each, charged: each * c.qty, unit: each, vid: c.v.id, sheets: c.qty };
  }
  // the lowest price per sheet for a length at any quantity, and at 1 sheet
  function fromCents(L) { var lo = 0; TIERS.forEach(function (t) { var x = centsFor(L, t); if (x > 0 && (!lo || x < lo)) lo = x; }); return lo; }

  // ---------- labels ----------
  function sheetTxt(L) { return '22 x ' + L + ' in'; }
  function sheetsTxt(n) { return plural(n, 'sheet'); }
  function modeLabel(c) { return c.mode === 'simple' ? 'One design, ' + plural(c.copies, 'copy', 'copies') : 'Gang sheet, ' + plural(c.count, 'design'); }
  function sizeChip(c) { return sheetTxt(c.len) + ' sheet'; }
  function deliveryLabel(c) { return c.delivery === 'pickup' ? 'Pick up at our Snohomish shop (free)' : 'Ship to me (free)'; }
  function designTxt(c) { return c.box ? fmt(c.box.w) + ' x ' + fmt(c.box.h) + ' in' : 'No design yet'; }
  function specLines(c) {
    var p = price(c), out = [['Sheet', sheetTxt(c.len) + ' (22 in wide)'], ['Layout', c.mode === 'simple' ? 'One design, copies placed for you' : 'Gang sheet']];
    if (c.mode === 'simple') {
      out.push(['Design size', designTxt(c)]);
      out.push(['Copies', c.plan && c.plan.ok ? c.copies + ' wanted, ' + c.per + ' per sheet x ' + sheetsTxt(c.qty) + ' = ' + (c.per * c.qty) + (c.turn ? ' (turned sideways on the sheet)' : '') : String(c.copies)]);
    } else out.push(['Designs', String(c.count)]);
    out.push(['Sheets', sheetsTxt(c.qty) + ' (' + money(p.each) + ' each, ' + tierName(c.qty) + ' price)']);
    out.push(['Delivery', deliveryLabel(c)]);
    return out;
  }

  // ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.data) b.setAttribute('data-' + opts.data[0], String(opts.data[1]));
    if (opts.disabled) b.disabled = true;
    if (opts.title) b.title = opts.title;
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    if (!el) return;
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function set(patch) { Object.assign(S, patch); render(); }
  function setText(sel, t) { var el = $(sel); if (el) el.textContent = t; }
  function setVal(sel, v) { var el = $(sel); if (el && document.activeElement !== el) el.value = v; }

  // ---------- mode, sizes, copies, sheet length ----------
  function pickMode(m) {
    if (m === S.mode) return;
    var c = cfg();
    if (m === 'gang') {
      // keep the design where it is, on the same sheet length
      S.len = c.len; S.sheets = 1; S.mode = 'gang';
      if (c.count) toast('Gang sheet: drag your designs anywhere on the sheet, add more, then fit the sheet to them.');
    } else {
      S.mode = 'simple';
      if (c.count > 1) toast('One design: everything on the sheet now prints as one design, copied for you. Use Undo or Gang sheet to go back.');
    }
    lay.zoom = 0; render(); normalizeSoon();
  }
  // one design: scale everything together (from its top-left) to a new width or height in inches
  function sizeDesign(w, h) {
    var fc = FC(), bb = masterBox(); if (!fc || !bb) return;
    var k = w ? w / bb.w : h / bb.h;
    if (!(k > 0) || !isFinite(k)) return;
    var max = Math.min((SHEET_W - 2 * MARGIN) / bb.w, (LMAX - 2 * MARGIN) / bb.h); if (k > max) k = max;
    objs().forEach(function (o) {
      o.set({ left: bb.x + (o.left - bb.x) * k, top: bb.y + (o.top - bb.y) * k, scaleX: o.scaleX * k, scaleY: o.scaleY * k });
      o.setCoords();
    });
    fc.requestRenderAll(); layersChanged();
  }
  // one object: scale it to a new width or height (keeps its center)
  function sizeObj(o, w, h) {
    var fc = FC(); if (!fc || !o) return;
    var b = boxOf(o), k = w ? w / b.w : h / b.h;
    if (!(k > 0) || !isFinite(k)) return;
    o.scale(o.scaleX * k); o.setCoords();
    fc.requestRenderAll(); layersChanged();
  }
  function setCopies(n) { S.copies = clamp(Math.round(num(n, 1)), 1, MAX_COPIES); render(); normalizeSoon(); }
  function setLen(L) { S.len = clamp(Math.round(num(L, S.len)), LMIN, LMAX); S.lenTouched = true; render(); }
  function setQty(n) { var v = Math.round(num(n, 1)), over = v > MAX_QTY; if (over) { S.quoteSheets = v; v = MAX_QTY; } S.sheets = clamp(v, 1, MAX_QTY); render(); if (over) openQuote(); }
  function fitSheet() {
    var b = objs().map(boxOf); if (!b.length) { toast('Add a design first.'); return; }
    var L = E.fitLen(b), was = S.len;
    S.len = L; render();
    toast(L === was ? 'The sheet already fits your designs: ' + sheetTxt(L) + '.' : 'Sheet set to ' + sheetTxt(L) + ' to fit your designs.');
  }
  function arrangeAll() {
    var fc = FC(), list = objs(); if (!fc || !list.length) { toast('Add a design first.'); return; }
    var bs = list.map(boxOf), r = E.arrange(bs);
    list.forEach(function (o, i) {
      var to = r.boxes[i], b = bs[i];
      if (to.turn) { o.rotate(((o.angle || 0) + 90) % 360); o.setCoords(); b = boxOf(o); }
      o.set({ left: o.left + (to.x - b.x), top: o.top + (to.y - b.y) }); o.setCoords();
    });
    S.len = r.len; fc.requestRenderAll(); layersChanged(); render();
    toast('Designs arranged 1/4 in apart. Sheet set to ' + sheetTxt(r.len) + '.');
  }
  function layersChanged() { var l = LY(); if (l && l.changed) l.changed(); else render(); }

  // one design: the design sits at the first copy's spot (top left of the grid); the other copies follow it
  var normT = 0;
  function normalizeSoon() { clearTimeout(normT); normT = setTimeout(function () { if (normalize()) render(); }, 30); }
  function normalize() {
    if (S.mode !== 'simple') return false;
    var fc = FC(); if (!fc || fc._currentTransform) return false;
    var list = objs(); if (!list.length) return false;
    var act = fc.getActiveObject(); if (act && act.isEditing) return false;
    var c = cfg(), bb = c.box, slot = c.layout && c.layout.slots[0];
    if (c.turn) return false;
    var tx = slot ? slot.x : clamp((SHEET_W - bb.w) / 2, MARGIN, SHEET_W), ty = MARGIN;
    var dx = tx - bb.x, dy = ty - bb.y;
    if (Math.abs(dx) < 1e-4 && Math.abs(dy) < 1e-4) return false;
    list.forEach(function (o) { o.set({ left: o.left + dx, top: o.top + dy }); o.setCoords(); });
    fc.requestRenderAll();
    return true;
  }

  // ---------- uploads ----------
  function fmtMB(b) { return (b / 1048576).toFixed(1) + ' MB'; }
  function ext(n) { var m = /\.([A-Za-z0-9]{1,5})$/.exec(n || ''); return m ? m[1].toLowerCase() : ''; }
  function kindOfFile(f) {
    var e = ext(f.name), t = String(f.type || '').toLowerCase();
    if (e === 'svg' || /svg/.test(t)) return 'svg';
    if (e === 'pdf' || /pdf/.test(t)) return 'pdf';
    if (e === 'ai') return 'ai';
    if (e === 'eps' || /postscript/.test(t)) return 'eps';
    if (e === 'psd' || /photoshop/.test(t)) return 'psd';
    if (e === 'tif' || e === 'tiff' || /tiff/.test(t)) return 'tif';
    if (/^(png|jpe?g|webp|gif|bmp|avif)$/.test(e) || /^image\//.test(t)) return 'image';
    return '';
  }
  function mkCanvas(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function decodeImg(blob) {
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(blob), im = new Image();
      im.decoding = 'async';
      im.onload = function () { res({ img: im, url: u, w: im.naturalWidth, h: im.naturalHeight }); };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
      im.src = u;
    });
  }
  // the picture as a canvas no bigger than maxArea pixels (and 16384 px a side); k = how much it was shrunk
  function toCanvas(src, w, h, maxArea) {
    var k = Math.min(1, Math.sqrt((maxArea || 64e6) / (w * h)), 16384 / w, 16384 / h);
    var cv = mkCanvas(w * k, h * k), x = cv.getContext('2d');
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    x.drawImage(src, 0, 0, cv.width, cv.height);
    return { canvas: cv, k: cv.width / w };
  }
  function artView() {
    var av = window.ArdorBannerArtView;
    if (av && av.config && !artView.done) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); artView.done = true; }
    return av;
  }
  // a file -> an IMGS entry (with el = the picture to show). Ready-made 22 in wide sheet PNGs are marked sheet = L.
  function loadEntry(file, opts) {
    opts = opts || {};
    var kind = kindOfFile(file);
    if (!kind) return Promise.reject(new Error('That file type isn\'t supported. Use PNG (best), JPG, PDF, SVG, AI, EPS, TIFF or PSD.'));
    if (file.size > MAX_FILE) return Promise.reject(new Error('That file is ' + fmtMB(file.size) + '. The limit is ' + fmtMB(MAX_FILE) + '. Email bigger files to info@ardorprinting.com.'));
    var id = 'd' + (++imgSeq) + '-' + Date.now().toString(36);
    var en = { id: id, name: file.name || 'design', file: file, kind: kind, vector: kind === 'svg' || kind === 'pdf' || kind === 'ai' || kind === 'eps', bg: null, sheet: 0, ai: !!opts.ai };
    var info = kind === 'image' && /png/i.test(file.type || ext(file.name)) && E ? E.pngInfo(file) : Promise.resolve(null);
    return info.then(function (pi) {
      en.png = pi;
      if (kind === 'image' || kind === 'svg') {
        return decodeImg(file).then(function (r) {
          var w = r.w, h = r.h;
          if (kind === 'svg') {
            if (!(w > 0 && h > 0)) { w = 1200; h = 1200; }
            var k0 = 3000 / Math.max(w, h); w *= k0; h *= k0; // vector: show it at 3000 px on the long side
          }
          en.srcW = kind === 'svg' ? Infinity : r.w; en.srcH = kind === 'svg' ? Infinity : r.h;
          var t = toCanvas(r.img, w, h, pi && pi.w * pi.h > 64e6 ? 16e6 : 64e6);
          en.el = t.canvas; en.k = kind === 'svg' ? 1 : t.k; en.w = r.w; en.h = r.h; en.img = r.img; en.url = r.url;
          if (kind !== 'svg' && t.k >= 0.999) { URL.revokeObjectURL(r.url); en.img = null; en.url = ''; }
          return en;
        });
      }
      var av = artView();
      if (!av || !av.preview) throw new Error('This file type needs a moment to load. Please try again, or upload a PNG.');
      return Promise.race([av.preview(file, { maxPx: 3000 }), new Promise(function (r) { setTimeout(function () { r({ ok: false }); }, 60000); })]).then(function (r) {
        if (!r || !r.ok || !r.canvas) throw new Error('We couldn\'t read that ' + kind.toUpperCase() + ' file. Save it as a PNG with a transparent background and upload that.');
        en.el = r.canvas; en.k = 1; en.w = r.canvas.width; en.h = r.canvas.height;
        en.srcW = en.vector ? Infinity : r.natW || r.canvas.width; en.srcH = en.vector ? Infinity : r.natH || r.canvas.height;
        return en;
      });
    }).then(function (en2) {
      en2.orig = en2.el;
      en2.info = E ? E.analyze(en2.el) : null;
      // a ready-made sheet: a PNG with transparency whose shape is 22 x a whole number of inches. Sure when the file says
      // it is 22 in wide (its dpi) or it is at least 6000 px wide; a smaller one (4400 px and up) is placed as a design
      // and the customer is asked whether it is a finished sheet.
      var pi2 = en2.png;
      if (pi2 && pi2.alpha) {
        var L = Math.round(SHEET_W * pi2.h / pi2.w), ratio = pi2.w / pi2.h, want = SHEET_W / L;
        var wideIn = pi2.dpi > 0 ? pi2.w / pi2.dpi : 0;
        if (L >= LMIN && L <= LMAX && Math.abs(ratio - want) / want < 0.01 && Math.abs(SHEET_W * pi2.h / pi2.w - L) <= 0.05) {
          if (Math.abs(wideIn - SHEET_W) < 0.3 || (pi2.w >= 6000 && !(wideIn > 0 && Math.abs(wideIn - SHEET_W) >= 0.3))) en2.sheet = L;
          else if (pi2.w >= 4400 && !(wideIn > 0 && Math.abs(wideIn - SHEET_W) >= 0.3)) en2.sheetMaybe = L;
        }
      }
      IMGS[en2.id] = en2;
      return en2;
    });
  }
  // an IMGS entry from a canvas that is already the art (AI designs after the cutout); file = the original picture
  function entryFromCanvas(cv, file, o) {
    o = o || {};
    var id = 'd' + (++imgSeq) + '-' + Date.now().toString(36);
    var en = { id: id, name: file.name || 'design.png', file: file, kind: 'image', vector: false, bg: null, sheet: 0, ai: !!o.ai, aiScale: o.aiScale || 1,
      el: cv, orig: cv, k: 1, w: cv.width, h: cv.height, srcW: cv.width, srcH: cv.height, img: null, url: '', png: null };
    en.info = E ? E.analyze(cv) : null;
    IMGS[id] = en;
    return en;
  }
  // the default print width for a new picture: its size at 300 dpi, 3 to 11 in, no taller than 14 in
  function defaultSize(en) {
    var ar = en.el.height / en.el.width, w;
    if (en.vector) w = 10;
    else w = clamp(en.srcW / PPI, 3, 11);
    if (w * ar > 14) w = 14 / ar;
    if (w > SHEET_W - 2 * MARGIN) w = SHEET_W - 2 * MARGIN;
    return { w: w, h: w * ar };
  }
  function addFiles(list) {
    var files = Array.prototype.slice.call(list || []).filter(Boolean);
    if (!files.length) return;
    showErr('');
    if (S.mode === 'simple' && files.length > 1) {
      S.mode = 'gang'; S.len = cfg().len;
      toast('More than one design: switched to Gang sheet so you can place them all.');
    }
    busyArt(true);
    var chain = Promise.resolve();
    files.forEach(function (f) {
      chain = chain.then(function () {
        return loadEntry(f).then(function (en) { return placeEntry(en, {}); }).catch(function (e) { showErr((e && e.message) || 'We couldn\'t read that file.'); });
      });
    });
    chain.then(function () { busyArt(false); render(); });
  }
  function busyArt(on) { var n = $('[data-abb-file-name]'); if (!n) return; if (on) { n.hidden = false; n.textContent = 'Reading your file…'; } else syncFileName(); }
  function syncFileName() {
    var n = $('[data-abb-file-name]'); if (!n) return;
    var names = []; objs().forEach(function (o) { var en = entryOf(o); if (en && names.indexOf(en.name) < 0) names.push(en.name); });
    n.hidden = !names.length; n.textContent = names.length ? 'On your sheet: ' + names.slice(0, 4).join(', ') + (names.length > 4 ? ' and ' + (names.length - 4) + ' more' : '') : '';
  }
  // put a picture on the sheet. o: { w (print width, in), place (placement preset id), select }
  function placeEntry(en, o) {
    o = o || {};
    var L = LY();
    if (!L || !L.addImage) return Promise.reject(new Error('The design tools are still loading. Please try again in a moment.'));
    var c = cfg();
    // a ready-made sheet: gang sheet of its length, placed edge to edge
    if (en.sheet) {
      S.mode = 'gang'; S.len = en.sheet; S.lenTouched = true;
      return L.addImage(en.el, { id: en.id, label: en.name, x: 0, y: 0, w: SHEET_W, h: en.sheet, center: false }).then(function (ob) {
        var ink = E.edgeInk(en.el, SHEET_W, en.sheet, MARGIN);
        en.edge = ink;
        render();
        toast('Ready-made ' + sheetTxt(en.sheet) + ' sheet file: placed edge to edge on a ' + sheetTxt(en.sheet) + ' sheet.' + (ink.share > 0.002 ? ' Some art is inside the 1/8 in edge and may be trimmed.' : ''));
        afterAdd(en);
        return ob;
      });
    }
    var sz = defaultSize(en);
    if (o.w) sz = { w: o.w, h: o.w * en.el.height / en.el.width };
    var pos;
    if (S.mode === 'simple') {
      // one design: a new picture replaces the pictures already there (text and clipart stay)
      var old = objs().filter(function (x) { return kindOf(x) === 'image'; });
      if (old.length && L.removeObjects) { L.removeObjects(old); toast('Your new design replaced the old one. Use Undo to bring it back.'); }
      pos = { x: (SHEET_W - sz.w) / 2, y: MARGIN };
    } else {
      pos = E.freeSpot(objs().map(boxOf), sz.w, sz.h, c.len);
      var need = Math.ceil(pos.y + sz.h + MARGIN - 1e-6);
      if (need > S.len) S.len = clamp(need, LMIN, LMAX);
    }
    return L.addImage(en.el, { id: en.id, label: en.name, x: pos.x, y: pos.y, w: sz.w, h: sz.h }).then(function (ob) {
      if (o.place) applyPlacement(o.place, ob);
      afterAdd(en);
      render(); normalizeSoon();
      return ob;
    });
  }
  // a picture that may be a finished 22 in wide sheet: placed as a design, then this turns it into the sheet
  function useAsSheet(en) {
    if (!en || !en.sheetMaybe) return;
    var L = LY(), old = objsOf(en);
    if (L && L.removeObjects && old.length) L.removeObjects(old);
    en.sheet = en.sheetMaybe; en.sheetMaybe = 0;
    placeEntry(en, {}).catch(function () {});
  }
  // after a picture is added: offer background removal when it has a solid background
  function afterAdd(en) {
    syncFileName();
    track0('ardor_dtf_layer_added', { layer: 'image' });
    if (en.sheetMaybe && !en.sheet) { ltoast('Is ' + en.name + ' a finished 22 in wide sheet? We can place it edge to edge on a ' + sheetTxt(en.sheetMaybe) + ' sheet.', 15000, { label: 'Use as ' + sheetTxt(en.sheetMaybe) + ' sheet', run: function () { useAsSheet(en); } }); return; }
    if (en.info && en.info.solidBg && !en.sheet) {
      if (en.autoBg) { removeBgFor(en, {}); return; }
      ltoast('This design has a solid ' + colorWord(en.info.bgColor) + ' background. DTF prints every pixel, so it would print as a box.', 12000, { label: 'Remove background', run: function () { removeBgFor(en, {}); } });
    } else if (en.info && en.info.opaque && !en.sheet) {
      ltoast('This design has no transparent areas, so it prints as a solid rectangle. Use a PNG with a transparent background if that\'s not what you want.', 9000);
    }
  }
  function colorWord(hex) {
    var v = parseInt(String(hex || '#ffffff').slice(1), 16), r = v >> 16 & 255, g = v >> 8 & 255, b = v & 255, mx = Math.max(r, g, b), mn = Math.min(r, g, b);
    if (mn > 225) return 'white'; if (mx < 40) return 'black'; if (mx - mn < 24) return 'gray';
    return 'colored';
  }
  function ltoast(msg, ms, action) { var l = LY(); if (l && l.toast) l.toast(msg, ms, action); else toast(msg); }

  // ---------- background removal (one click, Undo) ----------
  function objsOf(en) { return objs().filter(function (o) { return o.ablSrc === en.id; }); }
  function swapEl(en, el) {
    var fc = FC();
    objsOf(en).forEach(function (o) {
      var w = o.width * o.scaleX, h = o.height * o.scaleY;
      o.setElement(el);
      o.set({ scaleX: w / el.width, scaleY: h / el.height }); o.setCoords();
      o.dirty = true;
    });
    if (fc) fc.requestRenderAll();
  }
  function removeBgFor(en, opt) {
    if (!en || !E) return Promise.resolve();
    var base = en.orig || en.el;
    var big = (en.img && en.k < 0.999) ? null : base;
    ltoast('Removing the background…', 0);
    return new Promise(function (res) { setTimeout(res, 30); }).then(function () {
      var r = E.removeBg(big || base, { tolerance: opt.tolerance, feather: opt.feather, everywhere: opt.everywhere, color: opt.color });
      if (!r.changed) { ltoast('We didn\'t find a plain background to remove. If your design still has one, pick its color in the options.', 8000); return; }
      en.bg = { color: r.color, tolerance: r.tolerance, feather: r.feather, everywhere: r.everywhere, removed: r.removed };
      en.el = r.canvas; en.info = E.analyze(en.el); en.thin = null;
      swapEl(en, en.el);
      layersChanged(); render(); renderObjProps();
      track0('ardor_dtf_bg_removed', { removed: Math.round(r.removed * 1000) / 10 });
      ltoast('Background removed (' + colorWord(r.color) + ', ' + Math.round(r.removed * 100) + '% of the picture). Check it on the dark shirt preview.', 9000, { label: 'Undo', run: function () { undoBg(en); } });
      if (S.shirt === 'white' || S.shirt === 'heather-gray' || S.shirt === 'pink' || S.shirt === 'gold') { S.shirt = 'black'; syncShirt(true); }
    });
  }
  function undoBg(en) {
    if (!en || !en.bg) return;
    en.el = en.orig; en.bg = null; en.info = E.analyze(en.el); en.thin = null;
    swapEl(en, en.el); layersChanged(); render(); renderObjProps();
    ltoast('Background put back.', 4000);
  }

  // ---------- checks: background, resolution, fine details, edges ----------
  var thinCache = {};
  function thinFor(o) {
    var b = boxOf(o), key = (o.ablSrc || o.text || o.ablLabel || '') + '|' + fmt1(b.w) + 'x' + fmt1(b.h) + '|' + Math.round(o.angle || 0) + '|' + (entryOf(o) && entryOf(o).bg ? 'bg' : '') + '|' + (o.fontFamily || '') + (o.ablStroke || '');
    if (thinCache[key]) return thinCache[key];
    var r = { checked: false };
    try {
      // drawn at the picture's own resolution (100 to 300 px per inch; text and clipart at 200), at most 9 million px
      var en = entryOf(o), dpi = en && !en.vector ? dpiOf(o) : 200, ppi = clamp(dpi, 100, 300);
      if (b.w * b.h * ppi * ppi > 9e6) ppi = Math.sqrt(9e6 / (b.w * b.h));
      if (ppi >= 50) {
        var cv = mkCanvas(Math.max(2, b.w * ppi), Math.max(2, b.h * ppi)), x = cv.getContext('2d');
        x.setTransform(cv.width / b.w, 0, 0, cv.height / b.h, -b.x * cv.width / b.w, -b.y * cv.height / b.h);
        drawObj(x, o, null);
        r = E.thinCheck(cv, b.w, 0.02, ppi);
        cv.width = cv.height = 1;
      }
    } catch (e) { r = { checked: false }; }
    thinCache[key] = r;
    return r;
  }
  // warnings for one object (strong ones first): [{ level: 'strong'|'warn', text }]
  function issuesOf(o, c) {
    var out = [], en = entryOf(o), k = kindOf(o), b = boxOf(o), name = objName(o);
    if (k === 'image' && en) {
      var dpi = dpiOf(o);
      if (en.ai && dpi < 290) out.push({ level: 'warn', text: 'The AI design prints at about ' + Math.round(dpi) + ' dpi at ' + fmt(b.w) + ' in wide' + (en.aiScale > 1 ? ' (enlarged smoothly from the AI picture)' : '') + '. Fine detail may look soft; smaller sizes look sharper.' });
      else if (dpi < 150) out.push({ level: 'strong', text: name + ' prints at ' + Math.round(dpi) + ' dpi at ' + fmt(b.w) + ' in wide. It will look blurry. Use a bigger file, or make it smaller (300 dpi is best).' });
      else if (dpi < 290) out.push({ level: 'warn', text: name + ' prints at ' + Math.round(dpi) + ' dpi. 300 dpi at print size is best; it may look a little soft.' });
      if (en.info && en.info.solidBg && !en.sheet) out.push({ level: 'strong', text: name + ' still has a solid ' + colorWord(en.info.bgColor) + ' background, which prints as a box. Use Remove background.' });
      else if (en.info && en.info.opaque && !en.sheet) out.push({ level: 'warn', text: name + ' has no transparent areas, so it prints as a solid rectangle.' });
      if (en.sheet && en.edge && en.edge.share > 0.002) out.push({ level: 'warn', text: 'Your sheet file has art within 1/8 in of the edge. It may be trimmed.' });
    }
    if (k === 'text' && b.h < 0.2) out.push({ level: 'warn', text: name + ' is under 0.2 in tall. Small text may lose detail.' });
    // fine details: not while a design is being dragged or resized (checked again when it is let go)
    var fcx = FC(), t = fcx && fcx._currentTransform ? { checked: false } : thinFor(o);
    if (t.checked && t.thin > 0.004 && t.px > 12) out.push({ level: 'warn', text: name + ' has lines or dots thinner than 0.02 in (0.5 mm). They may not transfer.' });
    // edges: 1/8 in safe margin (a ready-made sheet file placed edge to edge is checked by its ink instead)
    if (!(en && en.sheet)) {
      var off = b.x < -0.01 || b.y < -0.01 || b.x + b.w > SHEET_W + 0.01 || b.y + b.h > c.len + 0.01;
      var near = b.x < MARGIN - 0.01 || b.y < MARGIN - 0.01 || b.x + b.w > SHEET_W - MARGIN + 0.01 || b.y + b.h > c.len - MARGIN + 0.01;
      if (off) out.push({ level: 'strong', text: name + ' runs off the sheet. The part outside will not print.' });
      else if (near) out.push({ level: 'warn', text: name + ' is closer than 1/8 in to the edge (the dashed red line). It may be trimmed.' });
    }
    return out;
  }
  function allIssues(c) {
    var out = [];
    if (c.mode === 'simple') {
      if (c.box && c.plan && !c.plan.ok) {
        if (c.plan.tooWide) out.push({ level: 'strong', text: 'Your design is ' + fmt(c.box.w) + ' in wide. The most that fits is 21.75 in (1/8 in from each edge). Make it smaller or turn it.' });
        else out.push({ level: 'strong', text: 'That many copies needs more than 100 sheets. Request a quote and we\'ll price it for you.' });
      }
      if (c.box && c.box.h > LMAX - 2 * MARGIN) out.push({ level: 'strong', text: 'Your design is taller than the longest sheet (120 in).' });
    }
    objs().forEach(function (o) {
      issuesOf(o, c).forEach(function (x) {
        if (c.mode === 'simple' && /edge|runs off/.test(x.text)) return; // one design: copies are placed for you
        out.push(x);
      });
    });
    return out.sort(function (a, b) { return (a.level === 'strong' ? 0 : 1) - (b.level === 'strong' ? 0 : 1); });
  }

  // ---------- drawing objects (proof, print, previews) ----------
  // o.render() with caching off; pictures from hi[id] when given (print size), else from the editor's picture
  function drawObj(ctx, o, hi) {
    var el = hi && o.ablSrc ? hi[o.ablSrc] : null;
    if (el && o.type === 'image') {
      var m = o.calcTransformMatrix();
      ctx.save(); ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      ctx.globalAlpha *= o.opacity == null ? 1 : o.opacity;
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(el, -o.width / 2, -o.height / 2, o.width, o.height);
      ctx.restore();
      return;
    }
    var oc = o.objectCaching, vis = o.visible;
    o.objectCaching = false; o.visible = true;
    ctx.save();
    ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic'; ctx.globalCompositeOperation = 'source-over'; if (ctx.setLineDash) ctx.setLineDash([]);
    try { o.render(ctx); } catch (e) {}
    ctx.restore();
    o.objectCaching = oc; o.visible = vis;
    if (oc) o.dirty = true;
  }
  function drawAll(ctx, list, hi) { list.forEach(function (o) { drawObj(ctx, o, hi); }); }
  // the design(s) as a picture: list of objects inside box b (inches), ppi pixels per inch, capped at maxPx pixels
  function compose(list, b, ppi, maxPx, hi) {
    var k = Math.min(ppi, Math.sqrt((maxPx || 4e6) / Math.max(1e-6, b.w * b.h)));
    var cv = mkCanvas(Math.max(1, b.w * k), Math.max(1, b.h * k)), x = cv.getContext('2d');
    x.setTransform(cv.width / b.w, 0, 0, cv.height / b.h, -b.x * cv.width / b.w, -b.y * cv.height / b.h);
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    drawAll(x, list, hi);
    return cv;
  }
  function checker(ctx, x, y, w, h, s, a, b) {
    ctx.fillStyle = a; ctx.fillRect(x, y, w, h);
    ctx.fillStyle = b;
    for (var yy = 0; yy * s < h; yy++) for (var xx = (yy % 2); xx * s < w; xx += 2) ctx.fillRect(x + xx * s, y + yy * s, Math.min(s, w - xx * s), Math.min(s, h - yy * s));
  }
  // one copy of the design picture in a slot: upright, or turned 90 degrees clockwise (c.turn)
  function drawSlot(x, img, s, c) {
    if (!c.turn) { x.drawImage(img, s.x, s.y, c.box.w, c.box.h); return; }
    x.save(); x.translate(s.x + c.box.h, s.y); x.rotate(Math.PI / 2); x.drawImage(img, 0, 0, c.box.w, c.box.h); x.restore();
  }
  // the sheet drawn for the proof: clear film as a light checker, every copy / design, the 1/8 in dashed red line
  function sheetPicture(c, longPx, hi) {
    var k = (longPx || 1800) / Math.max(c.Wi, c.Hi), cv = mkCanvas(c.Wi * k, c.Hi * k), x = cv.getContext('2d');
    x.setTransform(k, 0, 0, k, 0, 0);
    checker(x, 0, 0, c.Wi, c.Hi, 0.5, '#FFFFFF', '#ECEDEF');
    drawContent(x, c, k, hi);
    x.save(); x.strokeStyle = '#D71920'; x.lineWidth = 1.6 / k; x.setLineDash([6 / k, 4 / k]);
    x.strokeRect(MARGIN, MARGIN, c.Wi - 2 * MARGIN, c.Hi - 2 * MARGIN); x.restore();
    return cv;
  }
  // everything that prints on one sheet, in sheet inches
  function drawContent(x, c, ppi, hi) {
    var list = objs();
    if (!list.length) return;
    if (c.mode === 'simple' && c.box && c.layout) {
      var comp = compose(list, c.box, ppi, Math.min(64e6, ppi * ppi * c.box.w * c.box.h + 1), hi);
      c.layout.slots.forEach(function (s) { drawSlot(x, comp, s, c); });
      return;
    }
    x.save(); x.beginPath(); x.rect(0, 0, c.Wi, c.Hi); x.clip();
    drawAll(x, list, hi);
    x.restore();
  }

  // ---------- 2D sheet editor: the whole sheet fits the stage; zoom in and pan to work on part of a long sheet ----------
  // lay.scale = screen px per inch, lay.ox / lay.oy = where the sheet's top-left corner sits on the canvas (css px),
  // lay.zoom 1 = whole sheet, lay.cx / lay.cy = the view's center in sheet fractions when zoomed in.
  var lay = { canvas: null, scale: 1, drag: false, pan: false, hand: false, lx: 0, ly: 0, zoom: 0, cx: 0.5, cy: 0, ox: 0, oy: 0, fit: 1, lastL: 0 };
  var ghost = { key: '', cv: null };
  function zmax(c) { return Math.max(8, c.Hi / 4); }
  function drawLayout() {
    var cv = lay.canvas; if (!cv) return;
    var c = cfg(), Wi = c.Wi, Hi = c.Hi;
    var frame = cv.parentNode, cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app');
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20);
    var maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 560;
    var fit = Math.min(maxW / Wi, maxH / Hi);
    // a long sheet opens zoomed to its top (about 30 in showing); zoom 0 = not chosen yet
    if (!lay.zoom || lay.lastL !== Hi) {
      var want = lay.zoom ? lay.zoom : clamp(Math.min(maxW / Wi, maxH / Math.min(Hi, 30)) / fit, 1, zmax(c));
      if (!lay.zoom) { lay.zoom = want; lay.cy = 0; }
      lay.lastL = Hi;
    }
    lay.zoom = clamp(lay.zoom, 1, zmax(c));
    var z = fit * lay.zoom;
    var cssW = Math.max(1, Math.round(Math.min(Wi * z, maxW))), cssH = Math.max(1, Math.round(Math.min(Hi * z, maxH)));
    var hx = cssW / (2 * z * Wi), hy = cssH / (2 * z * Hi);
    lay.cx = hx >= 0.5 ? 0.5 : clamp(lay.cx, hx, 1 - hx);
    lay.cy = hy >= 0.5 ? 0.5 : clamp(lay.cy, hy, 1 - hy);
    lay.ox = cssW / 2 - lay.cx * Wi * z; lay.oy = cssH / 2 - lay.cy * Hi * z;
    lay.scale = z; lay.fit = fit;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var pw = Math.round(cssW * dpr), ph = Math.round(cssH * dpr);
    cv.style.width = cssW + 'px'; cv.style.height = cssH + 'px';
    if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
    var kx = cv.width / cssW, ky = cv.height / cssH;
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.setTransform(z * kx, 0, 0, z * ky, lay.ox * kx, lay.oy * ky);
    var u = 1 / z; // inches per css px
    // clear film: checker; a grid every inch
    var y0 = Math.max(0, -lay.oy / z - 1), y1 = Math.min(Hi, (cssH - lay.oy) / z + 1);
    checker(ctx, 0, Math.floor(y0 * 2) / 2, Wi, Math.ceil(y1 * 2) / 2 - Math.floor(y0 * 2) / 2, 0.5, '#FFFFFF', '#EEEFF1');
    ctx.strokeStyle = 'rgba(30, 40, 60, .07)'; ctx.lineWidth = u;
    ctx.beginPath();
    for (var gx = 1; gx < Wi; gx++) { ctx.moveTo(gx, y0); ctx.lineTo(gx, y1); }
    for (var gy = Math.ceil(y0); gy < y1; gy++) { ctx.moveTo(0, gy); ctx.lineTo(Wi, gy); }
    ctx.stroke();
    // one design: the copies after the first (the first is the live design on the overlay)
    if (c.mode === 'simple' && c.box && c.layout && (c.layout.slots.length > 1 || c.turn)) {
      var key = c.artVer + '|' + fmt(c.box.w) + 'x' + fmt(c.box.h) + '|' + Math.round(z * dpr * 10);
      if (ghost.key !== key) { ghost.cv = compose(objs(), c.box, z * dpr, 3e6, null); ghost.key = key; }
      c.layout.slots.forEach(function (s, i) {
        if ((i === 0 && !c.turn) || s.y > y1 || s.y + s.h < y0) return;
        drawSlot(ctx, ghost.cv, s, c);
      });
      ctx.save(); ctx.strokeStyle = 'rgba(40, 60, 90, .35)'; ctx.lineWidth = u; ctx.setLineDash([4 * u, 3 * u]);
      c.layout.slots.forEach(function (s) { if (s.y > y1 || s.y + s.h < y0) return; ctx.strokeRect(s.x, s.y, s.w, s.h); });
      ctx.restore();
    }
    // gang sheet: red outline around designs that run off the sheet or into the 1/8 in edge
    if (c.mode === 'gang') {
      ctx.save(); ctx.strokeStyle = '#D71920'; ctx.lineWidth = 2 * u; ctx.setLineDash([]);
      objs().forEach(function (o) {
        var en = entryOf(o); if (en && en.sheet) return;
        var b = boxOf(o);
        if (b.x < MARGIN - 0.01 || b.y < MARGIN - 0.01 || b.x + b.w > Wi - MARGIN + 0.01 || b.y + b.h > Hi - MARGIN + 0.01) ctx.strokeRect(b.x - 2 * u, b.y - 2 * u, b.w + 4 * u, b.h + 4 * u);
      });
      ctx.restore();
    }
    // the sheet edge, the 1/8 in safe line, inch marks along the top and left
    ctx.save();
    ctx.strokeStyle = '#16161B'; ctx.lineWidth = 1.2 * u; ctx.strokeRect(0, 0, Wi, Hi);
    ctx.strokeStyle = '#D71920'; ctx.lineWidth = 1.2 * u; ctx.setLineDash([5 * u, 4 * u]);
    ctx.strokeRect(MARGIN, MARGIN, Wi - 2 * MARGIN, Hi - 2 * MARGIN);
    ctx.setLineDash([]);
    ctx.strokeStyle = 'rgba(20, 20, 27, .55)'; ctx.lineWidth = u;
    ctx.beginPath();
    for (var tx = 1; tx < Wi; tx++) { var tl = (tx % 6 === 0 ? 7 : 4) * u; ctx.moveTo(tx, 0); ctx.lineTo(tx, tl); }
    for (var ty = Math.ceil(y0); ty < y1; ty++) { var tl2 = (ty % 6 === 0 ? 7 : 4) * u; ctx.moveTo(0, ty); ctx.lineTo(tl2, ty); }
    ctx.stroke();
    if (z > 7) {
      ctx.fillStyle = 'rgba(20, 20, 27, .6)'; ctx.font = '600 ' + (9 * u) + 'px Jost, Arial, sans-serif'; ctx.textBaseline = 'middle'; ctx.textAlign = 'left';
      var stepN = z > 18 ? 1 : (z > 10 ? 3 : 6);
      for (var ny = stepN; ny < y1; ny += stepN) if (ny > y0) ctx.fillText(String(ny), 9 * u, ny);
    }
    ctx.restore();
    syncZoomUi(c);
    try { root.dispatchEvent(new CustomEvent('ardor:dtf-view')); } catch (e) {}
  }
  function syncZoomUi(c) {
    var out = $('[data-abb-zoom2d-val]'); if (out) out.textContent = Math.round(lay.zoom * 100) + '%';
    var zi = $('[data-abb-zoom2d-in]'), zo = $('[data-abb-zoom2d-out]'), zf = $('[data-abb-zoom2d-fit]'), hb = $('[data-abb-hand]');
    var zoomed = lay.zoom > 1.001;
    if (!zoomed) lay.hand = false;
    if (zi) zi.disabled = lay.zoom >= zmax(c || cfg()) - 0.001;
    if (zo) zo.disabled = !zoomed;
    if (zf) zf.disabled = !zoomed;
    if (hb) { hb.hidden = !zoomed; hb.setAttribute('aria-pressed', lay.hand ? 'true' : 'false'); }
    if (lay.canvas) lay.canvas.style.cursor = lay.hand ? 'grab' : '';
    root.classList.toggle('abb--hand', !!lay.hand);
  }
  // zoom to z (1 = whole sheet); (px, py) = the canvas point (css px) that stays put, else the view's center
  function setZoom(z, px, py) {
    var c = cfg(), Z = clamp(z, 1, zmax(c));
    if (px != null && lay.scale > 0) {
      var ux = (px - lay.ox) / lay.scale / c.Wi, uy = (py - lay.oy) / lay.scale / c.Hi, z1 = lay.fit * Z;
      var cw = lay.canvas ? parseFloat(lay.canvas.style.width) || 0 : 0, ch = lay.canvas ? parseFloat(lay.canvas.style.height) || 0 : 0;
      lay.cx = ux + (cw / 2 - px) / (z1 * c.Wi); lay.cy = uy + (ch / 2 - py) / (z1 * c.Hi);
    }
    lay.zoom = Z;
    drawLayout();
  }
  function panBy(dx, dy) { var c = cfg(); lay.cx -= dx / (lay.scale * c.Wi); lay.cy -= dy / (lay.scale * c.Hi); drawLayout(); }
  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas, frame = cv.parentNode;
    // empty sheet area (the overlay passes the press down to this canvas): drag to move the view when zoomed in
    cv.addEventListener('pointerdown', function (e) {
      if (lay.zoom <= 1.001) return;
      lay.pan = true; lay.lx = e.clientX; lay.ly = e.clientY;
      e.preventDefault();
      var move = function (ev) { if (!lay.pan) return; panBy(ev.clientX - lay.lx, ev.clientY - lay.ly); lay.lx = ev.clientX; lay.ly = ev.clientY; };
      var up = function () { lay.pan = false; window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', up); window.removeEventListener('pointercancel', up); };
      window.addEventListener('pointermove', move); window.addEventListener('pointerup', up); window.addEventListener('pointercancel', up);
    });
    // wheel: scroll the sheet up and down; with Ctrl / Cmd (or a pinch on a trackpad): zoom at the pointer
    (frame || cv).addEventListener('wheel', function (e) {
      if (!root.classList.contains('abb--app')) return;
      var r = cv.getBoundingClientRect();
      if (e.ctrlKey || e.metaKey) { e.preventDefault(); setZoom(lay.zoom * Math.exp(-e.deltaY * 0.0022), e.clientX - r.left, e.clientY - r.top); return; }
      if (lay.zoom <= 1.001) return;
      e.preventDefault(); panBy(-(e.shiftKey ? e.deltaY : e.deltaX) * 0.9, -(e.shiftKey ? 0 : e.deltaY) * 0.9);
    }, { passive: false });
    var on2 = function (sel, fn) { var b = $(sel); if (b) b.addEventListener('click', fn); };
    on2('[data-abb-zoom2d-in]', function () { setZoom(lay.zoom * 1.5); });
    on2('[data-abb-zoom2d-out]', function () { setZoom(lay.zoom / 1.5); });
    on2('[data-abb-zoom2d-fit]', function () { lay.cx = 0.5; lay.cy = 0.5; setZoom(1); });
    on2('[data-abb-hand]', function () { lay.hand = !lay.hand; syncZoomUi(); });
    window.addEventListener('resize', function () { drawLayout(); });
  }

  // ---------- t-shirt preview (2D, and 3D when assets/ardor-dtf3d.js is on the page) ----------
  function placeObj() { return SH ? SH.placementOf(S.place) : { id: 'front', area: 'front', w: 11, x: 0, y: 3 }; }
  // the design shown on the shirt: one design = all of it; gang sheet = the selected design, else the first one
  function shownList() {
    var list = objs(); if (!list.length) return [];
    if (S.mode === 'simple') return list;
    var fc = FC(), a = fc && fc.getActiveObject();
    if (a && a.type === 'activeSelection') return a.getObjects();
    if (a && list.indexOf(a) >= 0) { shownList.last = a; return [a]; }
    if (shownList.last && list.indexOf(shownList.last) >= 0) return [shownList.last];
    return [list[0]];
  }
  function shirtPrint(maxPx) {
    var list = shownList(); if (!list.length) return null;
    var b = unionBox(list.map(boxOf)), p = placeObj();
    var cv = compose(list, b, 200, maxPx || 1.2e6, null);
    return { area: p.area, canvas: cv, widthIn: b.w, heightIn: b.h, xIn: p.x || 0, yIn: p.y == null ? 3 : p.y, list: list };
  }
  function shirtOpts(view) {
    var p = placeObj(), pr = shirtPrint();
    var v = view || (p.area === 'back' ? 'back' : 'front');
    return { color: S.shirt, view: v, size: p.size === 'youth' ? 'youth' : 'adult', prints: pr ? [pr] : [], print: pr };
  }
  var shirtT = 0;
  function syncShirt(now) {
    clearTimeout(shirtT);
    var go = function () {
      var cv = $('[data-adt-shirt]'); if (!cv || !SH) return;
      var box = cv.parentNode, w = box.clientWidth || 320, h = box.clientHeight || 320, dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); cv.style.width = w + 'px'; cv.style.height = h + 'px';
      var o = shirtOpts(); o.label = false;
      SH.draw(cv, o);
      sync3d(o);
      syncShirtBar(o);
    };
    if (now) go(); else shirtT = setTimeout(go, 90);
  }
  function syncShirtBar(o) {
    $$('[data-adt-color]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-adt-color') === S.shirt ? 'true' : 'false'); });
    $$('[data-adt-place]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-adt-place') === S.place ? 'true' : 'false'); });
    $$('[data-adt-show]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-adt-show') === S.show ? 'true' : 'false'); });
    var tip = $('[data-adt-shirt-tip]');
    if (tip) tip.textContent = (o.print ? (S.mode === 'gang' && objs().length > 1 ? 'Showing the selected design. ' : '') + 'True size: ' + fmt(o.print.widthIn) + ' x ' + fmt(o.print.heightIn) + ' in on ' + (o.size === 'youth' ? 'a youth M' : 'an adult L') + ' shirt. ' : 'Add a design to see it on a shirt. ') + 'We print the transfers; the shirt is a preview.';
    var box = $('[data-adt-shirtbox]'); if (box) box.setAttribute('data-show', S.show === '3d' && eng ? '3d' : '2d');
  }
  // a placement preset: one design = resize the whole design to the preset width; gang sheet = the selected design
  function applyPlacement(id, ob) {
    if (!SH) return;
    var p = SH.placementOf(id); S.place = p.id;
    if (S.mode === 'simple') { var bb = masterBox(); if (bb) sizeDesign(p.w, 0); }
    else { var fc = FC(), a = ob || (fc && fc.getActiveObject()); if (a && a.type !== 'activeSelection') sizeObj(a, p.w, 0); }
    syncShirt(); render();
  }

  // ---------- 3D shirt (window.ArdorDtf3D, three.js). Everything else works without it. ----------
  var eng = null, engTried = false, engKey = '', engArea = '';
  function startEngine() {
    if (eng || engTried) return eng;
    var D = window.ArdorDtf3D, host = $('[data-adt-3d]');
    if (!D || !D.create || !host) return null;
    engTried = true;
    try { eng = D.create(host, { background: '#F4F2EE' }); } catch (e) { eng = null; }
    var tg = $('[data-adt-show="3d"]'); if (tg) tg.hidden = !eng;
    if (!eng) { var ng = $('[data-abb-nogl]'); if (ng) ng.hidden = false; }
    return eng;
  }
  function sync3d(o) {
    if (!eng && window.ArdorDtf3D && !engTried) startEngine();
    if (!eng) return;
    o = o || shirtOpts();
    var p = o.print, k = S.shirt + '|' + o.size + '|' + (p ? p.area + fmt(p.widthIn) + fmt(p.heightIn) + fmt(p.xIn) + fmt(p.yIn) + S.artVer + objs().length : '');
    if (k === engKey) return;
    engKey = k;
    try {
      var col = SH ? SH.colorOf(S.shirt) : { hex: '#141414' };
      eng.set({ color: col.hex, heather: !!col.heather, size: o.size });
      ['front', 'back', 'sleeveL', 'sleeveR'].forEach(function (a) {
        // the 3D viewer's x runs to your right as you look at that area: on the back that is the wearer's right
        if (p && p.area === a) eng.setPrint(a, p.canvas, { widthIn: p.widthIn, heightIn: p.heightIn, xIn: a === 'back' ? -(p.xIn || 0) : (p.xIn || 0), yIn: p.yIn });
        else eng.setPrint(a, null);
      });
      if (p && p.area !== engArea) { engArea = p.area; view3d(p.area === 'back' ? 'back' : (/sleeve/.test(p.area) ? (p.area === 'sleeveR' ? 'right' : 'left') : 'home')); }
    } catch (e) {}
  }
  function view3d(v) { if (eng) { try { eng.view(v); } catch (e) {} } }

  // ---------- selected design: size, resolution, background tools (inside the layers' properties panel) ----------
  function renderObjProps() {
    var host = document.querySelector('[data-adt-objprops]'); if (!host) return;
    var fc = FC(), o = fc && fc.getActiveObject();
    if (!o || o.type === 'activeSelection' || o.isEditing === undefined && false) { host.textContent = ''; host.hidden = true; return; }
    host.hidden = false;
    var b = boxOf(o), en = entryOf(o), k = kindOf(o), c = cfg();
    var h = '<div class="adt-objsize"><span class="abl-label">Print size</span><div class="adt-wh">' +
      '<label><span>W</span><input class="abl-input" type="number" step="0.05" min="0.25" max="21.75" value="' + fmt(b.w) + '" data-adt-ow aria-label="Width in inches"></label>' +
      '<span class="adt-x">x</span>' +
      '<label><span>H</span><input class="abl-input" type="number" step="0.05" min="0.25" max="119.75" value="' + fmt(b.h) + '" data-adt-oh aria-label="Height in inches"></label><span class="adt-in">in</span></div></div>';
    if (k === 'image' && en) {
      var dpi = dpiOf(o);
      h += '<p class="adt-dpi ' + (dpi < 150 ? 'is-bad' : (dpi < 290 ? 'is-warn' : 'is-ok')) + '">' + (en.vector ? 'Vector file: sharp at any size' : Math.round(dpi) + ' dpi at this size' + (dpi < 150 ? ' (too low)' : (dpi < 290 ? ' (300 is best)' : ''))) + '</p>';
      if (!en.sheet) {
        h += '<div class="adt-bg"><span class="abl-label">Background</span>';
        if (en.bg) h += '<p class="abl-help">Removed: ' + esc(colorWord(en.bg.color)) + ' (' + Math.round(en.bg.removed * 100) + '%). Check the edges on the dark preview.</p>';
        else if (en.info && en.info.solidBg) h += '<p class="adt-warn">Solid ' + esc(colorWord(en.info.bgColor)) + ' background found. It would print as a box.</p>';
        else h += '<p class="abl-help">' + (en.info && en.info.transparent > 0.02 ? 'Transparent background.' : 'No plain background found.') + '</p>';
        h += '<div class="adt-bg__row"><button type="button" class="abl-done adt-bgbtn" data-adt-bg-run>' + (en.bg ? 'Remove again' : 'Remove background') + '</button>' + (en.bg ? '<button type="button" class="abl-done" data-adt-bg-undo>Undo</button>' : '') + '</div>' +
          '<details class="adt-bg__more"><summary>Fine-tune</summary>' +
          '<label class="adt-range"><span>Tolerance</span><input type="range" min="2" max="60" step="1" value="' + (en.bg ? en.bg.tolerance : 18) + '" data-adt-bg-tol></label>' +
          '<label class="adt-range"><span>Edge softness</span><input type="range" min="0" max="4" step="0.5" value="' + (en.bg ? en.bg.feather : 1.5) + '" data-adt-bg-feather></label>' +
          '<label class="adt-check"><input type="checkbox" data-adt-bg-all' + (en.bg && en.bg.everywhere ? ' checked' : '') + '> Also inside the design (letter holes)</label>' +
          '<label class="adt-check adt-check--color">Background color <input type="color" value="' + esc((en.bg && en.bg.color) || (en.info && en.info.bgColor) || '#FFFFFF') + '" data-adt-bg-color></label>' +
          '</details>' +
          '<canvas class="adt-darkprev" data-adt-darkprev width="240" height="120" aria-label="Your design on a dark shirt"></canvas></div>';
      }
    }
    var iss = issuesOf(o, c).filter(function (x) { return !(c.mode === 'simple' && /edge|runs off/.test(x.text)); });
    if (iss.length) h += '<ul class="adt-issues">' + iss.map(function (x) { return '<li class="' + (x.level === 'strong' ? 'is-bad' : 'is-warn') + '">' + esc(x.text) + '</li>'; }).join('') + '</ul>';
    host.innerHTML = h;
    var w = $('[data-adt-ow]', host), hh = $('[data-adt-oh]', host);
    var apply = function (isW) {
      var v = num((isW ? w : hh).value, 0); if (!(v > 0.1)) return;
      if (c.mode === 'simple') { var bb = masterBox(); if (objs().length > 1 && bb) { var kk = isW ? v / b.w : v / b.h; sizeObj(o, b.w * kk, 0); } else sizeDesign(isW ? v : 0, isW ? 0 : v); }
      else sizeObj(o, isW ? v : 0, isW ? 0 : v);
      renderObjProps();
    };
    w.addEventListener('change', function () { apply(true); });
    hh.addEventListener('change', function () { apply(false); });
    if (en && !en.sheet && k === 'image') {
      var opt = function () {
        return { tolerance: num($('[data-adt-bg-tol]', host).value, 18), feather: num($('[data-adt-bg-feather]', host).value, 1.5), everywhere: $('[data-adt-bg-all]', host).checked, color: $('[data-adt-bg-color]', host).value };
      };
      var run = $('[data-adt-bg-run]', host); if (run) run.addEventListener('click', function () { removeBgFor(en, opt()); });
      var und = $('[data-adt-bg-undo]', host); if (und) und.addEventListener('click', function () { undoBg(en); });
      ['[data-adt-bg-tol]', '[data-adt-bg-feather]', '[data-adt-bg-all]', '[data-adt-bg-color]'].forEach(function (s) { var x = $(s, host); if (x) x.addEventListener('change', function () { if (en.bg) removeBgFor(en, opt()); }); });
      var dp = $('[data-adt-darkprev]', host);
      if (dp) {
        var dx = dp.getContext('2d'); dx.fillStyle = '#141414'; dx.fillRect(0, 0, dp.width, dp.height);
        var r = Math.min((dp.width - 16) / en.el.width, (dp.height - 16) / en.el.height);
        dx.drawImage(en.el, (dp.width - en.el.width * r) / 2, (dp.height - en.el.height * r) / 2, en.el.width * r, en.el.height * r);
      }
    }
  }
  var propsT = 0;
  function renderObjPropsSoon() { clearTimeout(propsT); propsT = setTimeout(renderObjProps, 120); }

  // ---------- render ----------
  function render() {
    var c = cfg();
    var p = price(c);
    var simple = c.mode === 'simple';

    // 1. layout: one design with copies, or a gang sheet
    fill($('[data-adt-modes]'), [
      optBtn({ on: simple, data: ['mode', 'simple'], html: '<span class="abb-opt__name">One design</span><span class="abb-opt__sub">Copies placed for you</span>', pick: function () { pickMode('simple'); } }),
      optBtn({ on: !simple, data: ['mode', 'gang'], html: '<span class="abb-opt__name">Gang sheet</span><span class="abb-opt__sub">Place many designs yourself</span>', pick: function () { pickMode('gang'); } })
    ]);
    setText('[data-adt-mode-note]', simple ? 'One design, as many copies as you need. We lay them out 1/4 in apart and pick the cheapest sheet.' : 'Put different designs on one 22 in wide sheet. Drag them anywhere inside the dashed line.');

    // 2. design size and placement presets (one design)
    $$('[data-adt-simple]').forEach(function (n) { n.hidden = !simple; });
    $$('[data-adt-gang]').forEach(function (n) { n.hidden = simple; });
    setVal('[data-adt-w]', c.box ? fmt(c.box.w) : '');
    setVal('[data-adt-h]', c.box ? fmt(c.box.h) : '');
    $$('[data-adt-w], [data-adt-h]').forEach(function (n) { n.disabled = !c.box; });
    fill($('[data-adt-places]'), (SH ? SH.PLACEMENTS : []).map(function (pl) {
      return optBtn({ chip: true, on: pl.id === S.place, data: ['place', pl.id], label: pl.name + ' ' + fmt(pl.w) + '"', title: pl.name + ': ' + pl.w + ' in wide', pick: function () { applyPlacement(pl.id); } });
    }));
    setText('[data-adt-size-note]', c.box ? 'Your design prints ' + designTxt(c) + '.' : 'Upload a design, or add text or clipart.');

    // 3. copies (one design) / sheet length (gang sheet)
    setVal('[data-adt-copies]', String(c.copies || S.copies));
    var cm = $('[data-adt-copies-minus]'); if (cm) cm.disabled = (c.copies || 1) <= 1;
    var pn = '';
    if (simple && c.box && c.plan) {
      if (c.plan.ok) {
        pn = c.qty === 1 ? 'All ' + c.copies + ' fit on one ' + sheetTxt(c.len) + ' sheet (' + c.plan.cols + ' across).' : 'Cheapest: ' + sheetsTxt(c.qty) + ' of ' + sheetTxt(c.len) + ', ' + c.per + ' copies each (' + c.per * c.qty + ' in all).';
        if (c.plan.sameCap > c.per && c.plan.sameLen > c.len) pn += ' Room for up to ' + c.plan.sameCap + ' per sheet for the same price (' + sheetTxt(c.plan.sameLen) + ').';
        if (c.turn) pn += ' The copies are turned sideways on the sheet so more fit (you cut them apart and press them upright)' + (c.turnSaves > 0.004 ? ', which saves ' + money(c.turnSaves) : '') + '.';
        else if (S.noTurn && c.turnSaves > 0.004) pn += ' Turning the copies sideways on the sheet would save ' + money(c.turnSaves) + '.';
      } else pn = c.plan.tooWide ? 'Your design is wider than 21.75 in. Make it smaller.' : 'More than 100 sheets: request a quote.';
    } else if (simple) pn = 'Add a design to see how many fit on a sheet.';
    setText('[data-adt-plan-note]', pn);
    var tb = $('[data-adt-turn]');
    if (tb) { tb.hidden = !(simple && (c.turn || (S.noTurn && c.turnSaves > 0.004))); tb.textContent = c.turn ? 'Keep the copies upright' : 'Turn them sideways'; }
    setVal('[data-adt-len]', String(c.len));
    fill($('[data-adt-len-chips]'), LEN_CHIPS.map(function (L) {
      var x = centsFor(L, c.qty);
      return optBtn({ chip: true, on: L === c.len, data: ['len', L], label: L + '"', title: sheetTxt(L) + (x ? ', ' + money(x / 100) + ' a sheet' : ''), pick: function () { setLen(L); } });
    }));
    var sn = '';
    if (!simple) {
      var used = c.box ? E.fitLen(objs().map(boxOf)) : 0;
      sn = c.count ? 'Your designs use ' + (used ? sheetTxt(used) : 'the sheet') + '.' : 'Add designs, then fit the sheet to them.';
      if (used && used < c.len) { var save = (centsFor(c.len, c.qty) - centsFor(used, c.qty)) / 100; sn += save > 0.004 ? ' Fit the sheet to save ' + money(save * c.qty) + '.' : ' A shorter sheet costs the same.'; }
      if (used > c.len) sn += ' Some designs run past the end of the sheet.';
    }
    setText('[data-adt-sheet-note]', sn);

    // 4. quantity of sheets (gang sheet; one design picks it)
    var qIn = $('[data-abb-qty]'); if (qIn && document.activeElement !== qIn) qIn.value = String(c.qty);
    var qm = $('[data-abb-qty-minus]'), qp = $('[data-abb-qty-plus]'); if (qm) qm.disabled = c.qty <= 1 || simple; if (qp) qp.disabled = c.qty >= MAX_QTY || simple;
    if (qIn) qIn.disabled = simple;
    setText('[data-abb-qty-note]', simple ? (c.plan && c.plan.ok ? 'We picked ' + sheetsTxt(c.qty) + ' for your copies.' : '') : (c.qty > 1 ? sheetsTxt(c.qty) + ' at ' + money(p.each) + ' each (' + tierName(c.qty) + ' price). Every sheet has the same layout.' : money(p.each) + ' for one sheet. More sheets cost less each.'));

    // 5. delivery: free shipping or free pickup
    fill($('[data-abb-delivery]'), [
      optBtn({ on: c.delivery === 'ship', data: ['delivery', 'ship'], html: '<span class="abb-opt__name">Ship it to me (free)</span><span class="abb-opt__sub">Free shipping to your address</span>', pick: function () { set({ delivery: 'ship' }); } }),
      optBtn({ on: c.delivery === 'pickup', data: ['delivery', 'pickup'], html: '<span class="abb-opt__name">Pick up at our Snohomish shop (free)</span><span class="abb-opt__sub">' + esc(PICKUP) + '</span>', pick: function () { set({ delivery: 'pickup' }); } })
    ]);

    // number the steps that are showing
    var n = 0;
    $$('.abb-step').forEach(function (st) { var b = $('.abb-step__num', st); if (!b) return; if (!st.hidden) n++; b.textContent = String(n || 1); });

    // price box
    setText('[data-abb-total]', p.each > 0 ? money(p.charged) : 'Call us');
    setText('[data-abb-mbar-total]', money(p.charged));
    setText('[data-abb-dbar-total]', money(p.charged));
    var eachEl = $('[data-abb-each]');
    if (eachEl) { eachEl.hidden = !(p.each > 0); eachEl.textContent = sheetsTxt(c.qty) + ' x ' + money(p.each) + ' (' + sheetTxt(c.len) + ')' + (simple && c.box && c.plan && c.plan.ok ? ', ' + (c.per * c.qty) + ' copies, ' + money(p.charged / (c.per * c.qty)) + ' each' : ''); }
    var specs = $('[data-abb-specs]');
    if (specs) { specs.textContent = ''; specLines(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); }); }
    var dl = c.delivery === 'pickup' ? 'Free pickup at our Snohomish shop' : 'Free shipping';
    setText('[data-abb-free]', dl + '. You approve your proof before checkout.');
    $$('[data-abb-dnote]').forEach(function (el) { el.textContent = dl; });

    // warnings
    var iss = allIssues(c), warn = $('[data-abb-warn]');
    if (warn) { warn.hidden = !iss.length; warn.textContent = iss.length ? iss[0].text + (iss.length > 1 ? ' (+' + (iss.length - 1) + ' more)' : '') : ''; warn.classList.toggle('is-strong', !!(iss[0] && iss[0].level === 'strong')); }

    var rl = root.querySelector('[data-abx-row="sheet"] .abx-row__label'); if (rl) rl.textContent = simple ? 'Copies' : 'Sheet length';
    // summary chips and the stage tip
    setText('[data-abb-chip-size]', sizeChip(c));
    setText('[data-abb-chip-mat]', simple ? plural(c.copies, 'copy', 'copies') : plural(c.count, 'design'));
    setText('[data-abb-chip-sides]', sheetsTxt(c.qty));
    setText('[data-abb-tip]', simple ? (c.turn ? 'Copies turned sideways to fit more. Edit the design size on the right, or keep them upright.' : 'Copies are placed for you. Keep it inside the red line.') : 'Keep designs inside the dashed red line, 1/4 in apart.');
    syncFileName();
    var fcv = FC(), hide = simple && !!c.turn;
    if (fcv && fcv.wrapperEl) {
      fcv.wrapperEl.style.visibility = hide ? 'hidden' : '';
      if (hide && fcv.getActiveObject()) { fcv.discardActiveObject(); fcv.requestRenderAll(); }
    }
    drawLayout();
    syncShirt();
    renderObjPropsSoon();
  }
  // called by ardor-dtf-layers.js after designs change (moved, resized, added, removed)
  var artT = 0;
  function renderArtOnly() {
    clearTimeout(artT);
    artT = setTimeout(function () { S.artVer++; if (!(FC() && FC()._currentTransform)) normalize(); render(); }, 16);
  }

  // ---------- proof sheet and print files ----------
  function track0(name, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {} }
  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }
  function placeTxt() { var p = placeObj(); return p.name + ' (' + fmt(p.w) + ' in preset)'; }
  function designsTxt(c) {
    var list = objs();
    if (c.mode === 'simple') return designTxt(c) + (list.length > 1 ? ' (' + list.map(objName).join(' + ') + ')' : (list[0] ? ' (' + objName(list[0]) + ')' : ''));
    return list.map(function (o) { var b = boxOf(o); return objName(o) + ' ' + fmt(b.w) + ' x ' + fmt(b.h) + ' in'; }).join('; ');
  }
  function proofSpecs(c) {
    var p = price(c), out = [['Product', 'DTF transfers (you press them onto your shirts)'], ['Sheet', sheetTxt(c.len) + ', ' + sheetsTxt(c.qty)]];
    if (c.mode === 'simple') {
      out.push(['Layout', 'One design, copies placed for you']);
      out.push(['Design', designsTxt(c)]);
      if (c.plan && c.plan.ok) out.push(['Copies', c.copies + ' ordered: ' + c.per + ' per sheet x ' + sheetsTxt(c.qty) + ' = ' + (c.per * c.qty) + ' printed' + (c.turn ? ', turned sideways on the sheet to fit more (cut apart and press upright)' : '')]);
    } else {
      out.push(['Layout', 'Gang sheet, ' + plural(c.count, 'design')]);
      out.push(['Designs', designsTxt(c)]);
    }
    out.push(['Price', sheetsTxt(c.qty) + ' x ' + money(p.each) + ' = ' + money(p.charged)]);
    out.push(['Delivery', deliveryLabel(c)]);
    out.push(['Shirt preview', SH ? SH.colorOf(S.shirt).name + ' shirt, ' + placeTxt().toLowerCase() + '. Preview only: transfers only, no shirts.' : 'Preview only']);
    var iss = allIssues(c);
    if (iss.length) out.push(['Please check', iss.slice(0, 4).map(function (x) { return x.text; }).join(' ')]);
    var notes = ($('[data-abb-notes]') && $('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
    out.push(['How to press', PRESS]);
    return out;
  }
  // page 1 pictures: the 3D shirt when it is on the page (the proof sheet titles this box "in 3D"), then the flat shirt
  function proofViews(c) {
    var out = [], o = shirtOpts();
    if (!o.print || !SH) return out;
    if (!eng && window.ArdorDtf3D) startEngine();
    if (eng && typeof eng.snapshot === 'function') { try { engKey = ''; sync3d(o); var p3 = o.print, v = eng.snapshot(1000, 1030, p3 && p3.area === 'back' ? 'back' : (p3 && /sleeve/.test(p3.area) ? (p3.area === 'sleeveR' ? 'right' : 'left') : 'home')); if (v) out.push({ canvas: v, caption: 'In 3D on a ' + SH.colorOf(S.shirt).name.toLowerCase() + ' shirt (a guide)' }); } catch (e2) {} }
    try { var cv = SH.snapshot(1000, 1030, { color: S.shirt, view: o.view, size: o.size, prints: o.prints, label: true, bg: '#F4F2EE' }); out.push({ canvas: cv, caption: 'Flat preview, true size' }); } catch (e) {}
    return out.slice(0, 2);
  }
  function buildProof(c, approval, mode) {
    var PS = window.ArdorProofSheet;
    if (!PS || typeof PS.build !== 'function') return Promise.reject(new Error('proof tool'));
    var date = (approval && approval.when) || stampLabel(new Date());
    return logoImage().then(function (logo) {
      var face = { label: 'Print file: ' + sheetTxt(c.len) + ' sheet' + (c.mode === 'simple' ? ', ' + plural(c.per || 1, 'copy', 'copies') : ''), canvas: sheetPicture(c, 1800, null), wIn: c.Wi, hIn: c.Hi, wLabel: '22 in', hLabel: c.len + ' in' };
      return PS.build({
        logo: logo, title: 'Ardor DTF Transfer Proof', panelTitle: 'Your DTF transfers', noun: 'transfers', preview: mode === 'preview',
        views: proofViews(c), faces: [face], specs: proofSpecs(c), approval: approval || null, date: date,
        legend: 'Checkered = clear film (no ink). Dashed red line = 1/8 in from the edge. Transparent PNG, 300 dpi, ' + sheetTxt(c.len) + '.',
        disclaimer: 'Colors on screen and on this proof may differ slightly from the printed transfers. The shirt is a preview; we print transfers only. Press them as shown under How to press.',
        footer: 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com'
      });
    });
  }
  // pictures at print size: vector files drawn again big enough, very big pictures from the original file
  function hiResFor(list, ppi) {
    var hi = {}, jobs = [];
    list.forEach(function (o) {
      var en = entryOf(o); if (!en || hi[en.id] !== undefined) return;
      var need = Math.max(o.getScaledWidth(), o.getScaledHeight()) * ppi * 1.02;
      hi[en.id] = en.el;
      if (en.vector && en.kind === 'svg' && en.img) {
        var ar = en.el.height / en.el.width, w = Math.min(16384, Math.max(en.el.width, Math.ceil(o.getScaledWidth() * ppi)));
        if (w > en.el.width * 1.05) {
          var cv = mkCanvas(w, w * ar), x = cv.getContext('2d'); x.drawImage(en.img, 0, 0, cv.width, cv.height);
          if (en.bg) { var r = E.removeBg(cv, { tolerance: en.bg.tolerance, feather: en.bg.feather, everywhere: en.bg.everywhere, color: en.bg.color }); cv = r.canvas; }
          hi[en.id] = cv;
        }
      } else if (en.vector && window.ArdorBannerArtView && need > Math.max(en.el.width, en.el.height) * 1.1) {
        jobs.push(Promise.race([artView().preview(en.file, { maxPx: Math.min(16000, Math.round(need)) }), new Promise(function (r) { setTimeout(r, 45000); })]).then(function (r) {
          if (!r || !r.ok || !r.canvas) return;
          var cv2 = r.canvas;
          if (en.bg) cv2 = E.removeBg(cv2, { tolerance: en.bg.tolerance, feather: en.bg.feather, everywhere: en.bg.everywhere, color: en.bg.color }).canvas;
          hi[en.id] = cv2;
        }).catch(function () {}));
      } else if (!en.vector && en.k < 0.999 && en.img) {
        // the editor shows a smaller copy; print from the full picture (background removal is done again on it)
        if (en.bg) {
          jobs.push(Promise.resolve().then(function () {
            var full = toCanvas(en.img, en.w, en.h, 120e6).canvas;
            hi[en.id] = E.removeBg(full, { tolerance: en.bg.tolerance, feather: en.bg.feather, everywhere: en.bg.everywhere, color: en.bg.color }).canvas;
          }).catch(function () {}));
        } else hi[en.id] = en.img;
      }
    });
    return Promise.all(jobs).then(function () { return hi; });
  }
  // the print file: 22 x L in at 300 dpi, transparent, drawn in bands, as a PNG and a PDF copy
  function printFiles(c, onProgress) {
    if (!E) return Promise.reject(new Error('engine'));
    var list = objs();
    var ready = list.length === 1 ? entryOf(list[0]) : null, b0 = ready ? boxOf(list[0]) : null;
    var passPng = !!(ready && ready.sheet && ready.sheet === c.len && !ready.bg && ready.png && ready.png.w === SHEET_W * PPI && ready.png.h === c.len * PPI &&
      Math.abs(b0.x) < 0.01 && Math.abs(b0.y) < 0.01 && Math.abs(b0.w - SHEET_W) < 0.01 && Math.abs(b0.h - c.len) < 0.01 && !(list[0].angle % 360) && !list[0].flipX && !list[0].flipY);
    return hiResFor(list, PPI).then(function (hi) {
      var comp = null, slots = null;
      if (c.mode === 'simple' && c.box && c.layout) {
        var area = c.box.w * c.box.h * PPI * PPI;
        if (area <= 110e6) comp = compose(list, c.box, PPI, area + 1, hi);
        slots = c.layout.slots.map(function (s) { return { x: Math.round(s.x * PPI) / PPI, y: Math.round(s.y * PPI) / PPI }; });
      }
      var draw = function (ctx, yTop, yBot) {
        if (slots) {
          slots.forEach(function (s) {
            if (s.y > yBot || s.y + c.sh < yTop) return;
            if (comp) { drawSlot(ctx, comp, s, c); return; }
            ctx.save();
            if (c.turn) { ctx.translate(s.x + c.box.h, s.y); ctx.rotate(Math.PI / 2); ctx.translate(-c.box.x, -c.box.y); }
            else ctx.translate(s.x - c.box.x, s.y - c.box.y);
            drawAll(ctx, list, hi); ctx.restore();
          });
          return;
        }
        ctx.save(); ctx.beginPath(); ctx.rect(0, 0, SHEET_W, c.len); ctx.clip();
        list.forEach(function (o) { var b = boxOf(o); if (b.y > yBot || b.y + b.h < yTop) return; drawObj(ctx, o, hi); });
        ctx.restore();
      };
      return E.renderSheet({ Win: SHEET_W, Lin: c.len, ppi: PPI, draw: draw, pdf: true, png: !passPng, title: 'Ardor DTF Print File ' + sheetTxt(c.len), onProgress: onProgress }).then(function (r) {
        if (comp) comp.width = comp.height = 1;
        if (passPng) r.png = ready.file;
        return r;
      });
    });
  }
  // cloud storage for big files (assets/ardor-dtf-upload.js: window.ArdorDtfUpload.put(blob, { kind, name }) -> { url, key })
  function store(blob, kind, name, onProgress) {
    var U = window.ArdorDtfUpload;
    if (!U || typeof U.put !== 'function') return Promise.reject(new Error('storage'));
    return Promise.resolve(U.put(blob, { kind: kind, name: name, onProgress: onProgress })).then(function (r) {
      if (!r || !r.url) throw new Error('storage');
      return r;
    });
  }
  // ---------- messages, tracking, stamps ----------
  function toast(msg) {
    var t = $('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    // disabled Oct 18 2026 – duplicate of Shopify Google & YouTube / Facebook app event (add_to_cart / AddToCart). The generate_lead / Lead branch fired on the "Go to the quote form" link click, not on a sent lead; the lead itself is the HubSpot form submit, which GTM already sends as generate_lead + the Google Ads quote conversion. The dataLayer push above stays. Undo: remove "// " from the next 2 lines.
    // try { if (window.gtag) window.gtag('event', name === 'ardor_dtf_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    // try { if (window.fbq) window.fbq('track', name === 'ardor_dtf_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  // ---------- the approval window (the flag designer's dialog; the proof shows the shirt and the sheet) ----------
  function openApproval(c) {
    return new Promise(function (resolve, reject) {
      approveCtl = { resolve: resolve, reject: reject };
      var box = $('[data-abb-approve-proof]'); box.textContent = '';
      var figs = [];
      var o = shirtOpts();
      if (o.print && SH) figs.push([SH.snapshot(700, 720, { color: S.shirt, view: o.view, size: o.size, prints: o.prints, label: true, bg: '#F4F2EE' }), 'Preview on a shirt (true size)', 'Your design on a ' + SH.colorOf(S.shirt).name.toLowerCase() + ' shirt']);
      figs.push([sheetPicture(c, 1100, null), 'Print file: ' + sheetTxt(c.len) + ' sheet, ' + sheetsTxt(c.qty), 'Your DTF sheet']);
      figs.forEach(function (f) {
        var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
        var im = new Image(); im.alt = f[2]; im.src = f[0].toDataURL('image/jpeg', 0.86);
        var cap = document.createElement('figcaption'); cap.textContent = f[1];
        fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
      });
      var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
      proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
      $('[data-abb-approve-error]').hidden = true;
      $('[data-abb-ap-colors]').checked = false;
      var dlg = $('[data-abb-approve]');
      loadSigFont();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      setSigMode(coarse ? 'draw' : 'type');
    });
  }
  function submitApproval(e) {
    var PL = window.ArdorProofLater; if (PL && PL.on() && !(window.ArdorArtLink && window.ArdorArtLink.emailChosen(root))) { e.preventDefault(); var plr = PL.approve(root); if (plr) closeApproval(plr); return; } // DSN Oct 25 2026: one approval box now; name + typed signature in the cart, email + phone at checkout
    var AL = window.ArdorArtLink; if (AL && AL.emailChosen(root)) { e.preventDefault(); var pe = AL.proofEmail(root); if (pe) closeApproval({ emailProof: true, email: pe }); return; } // ART0 Oct 19 2026: "Email me the proof to approve"
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
      var copy;
      if (mode === 'type') copy = typedSigCanvas(typed);
      else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
      closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // ---------- cart ----------
  // One line: the sheet variant (length x quantity tier), quantity = the number of sheets, everything else as line item
  // properties. The signed proof goes with the line (small). The print files (transparent PNG at 300 dpi, exactly 22 x L in,
  // and a PDF copy) and the customer's original files go to cloud storage (assets/ardor-dtf-upload.js), with private
  // links in hidden properties, so the cart request stays far under Shopify's ~20 MB limit. Without the storage script,
  // files that fit go with the line instead (18 MB in all) and the rest is noted.
  function setupMsg() { return 'Online ordering for DTF transfers is being set up. Call ' + PHONE + ' or request a quote.'; }
  var CART_MAX = 18 * 1024 * 1024;
  var adding = false;
  function uniqueEntries() {
    var seen = {}, out = [];
    objs().forEach(function (o) { var en = entryOf(o); if (en && !seen[en.id]) { seen[en.id] = 1; out.push(en); } });
    return out;
  }
  function specJson(c, p, extra) {
    var list = objs();
    return JSON.stringify(Object.assign({
      v: p.vid, sku: c.v.sku || '', len: c.len, w: SHEET_W, n: c.qty, mode: c.mode, each: p.each, total: p.charged, del: c.delivery,
      copies: c.mode === 'simple' ? c.copies : undefined, per: c.mode === 'simple' ? c.per : undefined, turn: c.mode === 'simple' ? !!c.turn : undefined,
      box: c.box ? [+fmt(c.box.x), +fmt(c.box.y), +fmt(c.box.w), +fmt(c.box.h)] : null,
      items: list.slice(0, 60).map(function (o) { var b = boxOf(o), en = entryOf(o); return { k: kindOf(o), n: objName(o).slice(0, 60), x: +fmt(b.x), y: +fmt(b.y), w: +fmt(b.w), h: +fmt(b.h), a: Math.round(o.angle || 0), bg: en && en.bg ? en.bg.color : undefined, dpi: en && !en.vector ? Math.round(dpiOf(o)) : undefined }; }),
      shirt: S.shirt, place: S.place
    }, extra || {}));
  }
  function addToCart() {
    if (adding) return;
    showErr('');
    var c = cfg(), p = price(c);
    if (!objs().length) { showErr('Upload a design first, or add text or clipart.'); return; }
    if (c.mode === 'simple' && c.plan && !c.plan.ok) {
      if (c.plan.tooMany) { openQuote(); return; }
      showErr('Your design is wider than 21.75 in. Make it smaller before you order.'); return;
    }
    if (!p.vid || !c.v.available) { showErr(setupMsg()); return; }
    var block = allIssues(c).filter(function (x) { return x.level === 'strong' && /runs off|wider than|taller than/.test(x.text); });
    if (block.length) { showErr(block[0].text); return; }
    var fc = FC(); if (fc) { var act = fc.getActiveObject(); if (act && act.isEditing) act.exitEditing(); }
    adding = true;
    var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')].filter(Boolean);
    var label = function (t) { btns.forEach(function (b) { b.textContent = t; }); };
    btns.forEach(function (b) { b.disabled = true; }); label('Adding…');
    var done = function () { adding = false; btns.forEach(function (b) { b.disabled = false; }); label('Add to cart'); };
    var approval = null, files = {}, links = { orig: [] }, notes = [], attach = {}, proofEmail = ''; // ART0: proofEmail
    var artLink = window.ArdorArtLink ? window.ArdorArtLink.link(root, uniqueEntries().map(function (en) { return en.file; })) : null; // ART0: artwork by link (fallback off for DTF)
    openApproval(c).then(function (ap) {
      if (ap && ap.emailProof) { proofEmail = ap.email; ap = null; } // ART0: "Email me the proof to approve"
      approval = ap;
      label('Saving your proof…');
      return buildProof(c, approval, 'final');
    }).then(function (proof) {
      files.proof = proof;
      label('Making your print file… 0%');
      return printFiles(c, function (f) { label('Making your print file… ' + Math.round(f * 100) + '%'); });
    }).then(function (pf) {
      files.png = pf.png; files.pdf = pf.pdf; files.px = [pf.w, pf.h];
      var stamp = stampFile((approval && approval.at) || new Date()), tag = '22x' + c.len; // ART0: approval is null for an emailed proof
      var nm = { png: 'Ardor DTF Print File ' + tag + ' ' + stamp + '.png', pdf: 'Ardor DTF Print File ' + tag + ' ' + stamp + '.pdf', proof: 'Ardor DTF Proof ' + stamp + '.pdf' };
      files.names = nm;
      var origs = uniqueEntries().filter(function (en) { return en.file && en.file.size; });
      // the files that fit go with the cart line (18 MB in all): used when there is no cloud storage on the page, or when
      // the print file's cloud upload failed but the files are small enough
      var attachFit = function () {
        var room = CART_MAX - files.proof.size;
        if (files.png.size > room) throw new Error('Your print file is ' + fmtMB(files.png.size) + ', too big to add to the cart from this page. Request a quote and we\'ll take it from there.');
        attach.png = true; room -= files.png.size;
        if (files.pdf.size <= room) { attach.pdf = true; room -= files.pdf.size; } else notes.push('PDF copy not attached (' + fmtMB(files.pdf.size) + ', over the online upload limit); the PNG is the print file.');
        attach.orig = [];
        origs.forEach(function (en) { if (en.file.size <= room) { attach.orig.push(en); room -= en.file.size; } else notes.push('Original file ' + en.name + ' not attached (over the online upload limit); the print file has the design.'); });
        return null;
      };
      var U = window.ArdorDtfUpload;
      if (!U || typeof U.put !== 'function') return attachFit();
      if (typeof U.newOrder === 'function') U.newOrder();
      var LIMIT = U.maxBytes || 100e6, mb = function (b) { return (b / 1e6).toFixed(1) + ' MB'; };
      var prog = function (what) { return function (f) { if (f >= 0 && f <= 1) label('Uploading ' + what + '… ' + Math.round(f * 100) + '%'); }; };
      label('Uploading your print file…');
      return store(files.png, 'print', nm.png, prog('your print file')).then(function (r) {
        links.png = r.url;
        label('Uploading the PDF copy…');
        return store(files.pdf, 'print', nm.pdf, prog('the PDF copy')).then(function (r2) { links.pdf = r2.url; }, function (e) {
          notes.push(e && e.code === 'too-big' ? 'PDF copy not uploaded (' + mb(files.pdf.size) + ', over the 100 MB online limit); the PNG is the print file.' : 'The PDF copy of the print file did not upload; the PNG is the print file.');
        }).then(function () {
          var chain = Promise.resolve();
          origs.forEach(function (en, i) {
            chain = chain.then(function () {
              label('Uploading your original files (' + (i + 1) + ' of ' + origs.length + ')…');
              return store(en.file, 'original', 'Ardor DTF Original ' + stamp + ' ' + (en.name || 'design')).then(function (r3) { links.orig.push(en.name + ': ' + r3.url); }, function () { notes.push('Original file ' + en.name + ' did not upload; the print file has the design.'); });
            });
          });
          return chain;
        }).then(function () {
          return store(files.proof, 'proof', nm.proof).then(function (r4) { links.proof = r4.url; }, function () {});
        });
      }, function (e) {
        if (files.png.size + files.proof.size <= CART_MAX) { notes.push('Cloud upload failed (' + ((e && (e.status || e.code)) || 'error') + '); files attached to this line instead.'); return attachFit(); }
        if ((e && e.code === 'too-big') || files.png.size > LIMIT) throw new Error('Your print file is ' + mb(files.png.size) + ', over our 100 MB online upload limit. Request a quote and we\'ll take it from there.');
        throw new Error('We couldn\'t upload your print file. Please check your connection and try again, or request a quote.');
      });
    }).then(function () {
      label('Adding to your cart…');
      var fd = new FormData();
      fd.append('id', String(p.vid));
      fd.append('quantity', String(c.qty));
      fd.append('properties[Layout]', c.mode === 'simple' ? 'One design, copies placed for you' : 'Gang sheet');
      fd.append('properties[Sheet]', sheetTxt(c.len));
      fd.append('properties[Sheets]', String(c.qty));
      if (c.mode === 'simple') {
        fd.append('properties[Design size]', designTxt(c));
        fd.append('properties[Copies]', c.copies + ' (' + c.per + ' per sheet, ' + (c.per * c.qty) + ' printed)');
      } else fd.append('properties[Designs]', String(c.count));
      fd.append('properties[Shirt preview]', (SH ? SH.colorOf(S.shirt).name : '') + ', ' + placeObj().name.toLowerCase() + ' (preview only)');
      fd.append('properties[Delivery]', deliveryLabel(c));
      var notesTxt = ($('[data-abb-notes]') && $('[data-abb-notes]').value || '').trim();
      if (notesTxt) fd.append('properties[Notes]', notesTxt);
      fd.append('properties[Designed in]', 'Ardor DTF Designer');
      if (artLink) fd.append('properties[Artwork link]', artLink.url); // ART0
      var stampDate = approval && approval.at ? approval.at : new Date();
      var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
      if (!approval) { fd.append('properties[_Ardor DTF Unsigned Proof - ' + labelStamp + ']', new File([files.proof], 'Ardor DTF Unsigned Proof ' + fileStamp + '.pdf', { type: 'application/pdf' })); fd.append('properties[Proof]', 'We\'ll email you a proof to approve before printing'); fd.append('properties[Proof approval]', 'Email - pending'); fd.append('properties[Proof email]', proofEmail); } else { // ART0: "Email me the proof to approve"
      fd.append('properties[Ardor DTF Proof - ' + labelStamp + ']', new File([files.proof], 'Ardor DTF Proof ' + fileStamp + '.pdf', { type: 'application/pdf' }));
      if (!approval.later) fd.append('properties[Approved by]', approval.name); // DSN: the name comes with the cart signature
      fd.append('properties[Approved on]', approval.when);
      if (!approval.later) fd.append('properties[_Approver email]', approval.email); // DSN: email + phone come from checkout
      if (!approval.later) fd.append('properties[_Approver phone]', approval.phone); else { fd.append('properties[Proof approval]', approval.later); fd.append('properties[_Proof sign]', 'cart'); } // DSN
      } // ART0
      if (links.png) fd.append('properties[_Print file PNG]', links.png);
      if (links.pdf) fd.append('properties[_Print file PDF]', links.pdf);
      if (links.orig.length) fd.append('properties[_Original files]', links.orig.join(' | '));
      if (links.proof) fd.append('properties[_Proof link]', links.proof);
      if (attach.png) fd.append('properties[_Ardor DTF Print File PNG - ' + labelStamp + ']', new File([files.png], files.names.png, { type: 'image/png' }));
      if (attach.pdf) fd.append('properties[_Ardor DTF Print File PDF - ' + labelStamp + ']', new File([files.pdf], files.names.pdf, { type: 'application/pdf' }));
      (attach.orig || []).forEach(function (en, i) { fd.append('properties[_Ardor DTF Original ' + (i + 1) + ' - ' + labelStamp + ']', en.file, 'Ardor DTF Original ' + fileStamp + ' ' + en.name); });
      var iss = allIssues(c);
      var pnote = ['DTF ' + sheetTxt(c.len) + ', ' + sheetsTxt(c.qty) + ' of the same layout (one artwork per job). Print file: ' + files.px[0] + ' x ' + files.px[1] + ' px transparent PNG, 300 dpi, exactly 22 x ' + c.len + ' in, artwork at least 1/8 in from every edge; PDF copy at the same size. Send the PNG as is (100% scale), quantity ' + c.qty + '.'];
      if (c.mode === 'simple') pnote.push('One design ' + designTxt(c) + ', ' + c.per + ' copies per sheet, 1/4 in apart' + (c.turn ? ', turned 90 degrees on the sheet' : '') + ' (' + c.copies + ' ordered, ' + (c.per * c.qty) + ' printed).');
      else pnote.push('Gang sheet with ' + plural(c.count, 'design') + ': ' + designsTxt(c) + '.');
      uniqueEntries().forEach(function (en) { if (en.bg) pnote.push('Background removed online from ' + en.name + ' (' + en.bg.color + ', tolerance ' + en.bg.tolerance + '): check the edges.'); });
      if (iss.length) pnote.push('Customer saw: ' + iss.slice(0, 5).map(function (x) { return x.text; }).join(' '));
      notes.forEach(function (n) { pnote.push(n); });
      fd.append('properties[_Print file note]', pnote.join(' '));
      fd.append('properties[_spec]', specJson(c, p, { px: files.px, png: links.png ? 'link' : (attach.png ? 'attached' : 'none') }));
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 400000) { var pct = Math.round(100 * e.loaded / e.total); label(pct < 100 ? 'Uploading… ' + pct + '%' : 'Adding…'); } };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) return resolve();
          var msg = 'We couldn\'t add this to your cart. Please try again, or request a quote.';
          try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; } catch (e) {}
          if (xhr.status === 404 || xhr.status === 422) msg = setupMsg();
          if (xhr.status === 413) msg = 'Your files are too big to upload with the order. Please request a quote.';
          reject(new Error(msg));
        };
        xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
        xhr.send(fd);
      });
    }).then(function () {
      track('ardor_dtf_added_to_cart', { value: p.charged, sheet: c.len, sheets: c.qty, mode: c.mode, copies: c.mode === 'simple' ? c.copies : 0, designs: c.count });
      toast(approval ? 'Added to your cart. Your signed proof is saved with your order.' : 'Added to your cart. We\'ll email you the proof to approve before we print.'); // ART0
      adding = false;
      window.location.href = CONF.cartUrl || '/cart';
    }).catch(function (err) {
      if (err && err.cancel) { done(); return; }
      showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done();
    });
  }
  // ---------- quote (HubSpot form) ----------
  function summaryText() {
    var c = cfg(); var p = price(c);
    var lines = specLines(c).map(function (l) { return l[0] + ': ' + l[1]; });
    if (objs().length) lines.push('Design files: ' + designsTxt(c) + ' (I will send the files)');
    if (S.quoteSheets) lines.push('Sheets wanted: ' + S.quoteSheets);
    var notes = ($('[data-abb-notes]') && $('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
    lines.push('Online price shown: ' + money(p.charged) + ' (' + sheetsTxt(c.qty) + ' x ' + money(p.each) + ')');
    return lines.join('\n');
  }
  function openQuote() {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText();
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = 'DTF transfers from the Ardor DTF Designer\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      var host = $('[data-abb-quote-dialog]') || document.body;
      host.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      host.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function on(sel, ev, fn) { var el = $(sel); if (el) el.addEventListener(ev, fn); }
  function bind() {
    // "More than 100 sheets? Request a quote"
    on('[data-abb-quote-link]', 'click', openQuote);
    var fileIn = $('[data-abb-file]');
    if (fileIn) fileIn.addEventListener('change', function () { var fs = fileIn.files ? Array.prototype.slice.call(fileIn.files) : []; fileIn.value = ''; addFiles(fs); });
    var drop = $('[data-abb-drop]');
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) { addFiles(e.dataTransfer && e.dataTransfer.files); });
    }
    on('[data-abb-add]', 'click', addToCart);
    on('[data-abb-add-m]', 'click', addToCart);
    on('[data-abb-add-d]', 'click', addToCart);
    on('[data-abb-quote]', 'click', openQuote);
    on('[data-abb-quote-close]', 'click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    on('[data-abb-quote-copy]', 'click', copyQuote);
    on('[data-abb-quote-go]', 'click', function () { track('ardor_dtf_quote_request', { value: price(cfg()).charged }); });
    // design size (one design), copies, sheet length, sheets
    on('[data-adt-w]', 'change', function (e) { var v = num(e.target.value, 0); if (v > 0.1) sizeDesign(v, 0); else render(); });
    on('[data-adt-h]', 'change', function (e) { var v = num(e.target.value, 0); if (v > 0.1) sizeDesign(0, v); else render(); });
    var cp = $('[data-adt-copies]'), cpT = 0;
    if (cp) {
      cp.addEventListener('input', function () { clearTimeout(cpT); var v = parseInt(cp.value, 10); if (v >= 1) cpT = setTimeout(function () { setCopies(v); }, 250); });
      cp.addEventListener('change', function () { clearTimeout(cpT); setCopies(cp.value); });
    }
    on('[data-adt-copies-minus]', 'click', function () { setCopies(cfg().copies - 1); });
    on('[data-adt-copies-plus]', 'click', function () { setCopies(cfg().copies + 1); });
    on('[data-adt-len]', 'change', function (e) { setLen(e.target.value); });
    on('[data-adt-turn]', 'click', function () { S.noTurn = !cfg().turn ? false : true; render(); normalizeSoon(); });
    $$('[data-adt-fit]').forEach(function (b) { b.addEventListener('click', fitSheet); });
    $$('[data-adt-arrange]').forEach(function (b) { b.addEventListener('click', arrangeAll); });
    var q = $('[data-abb-qty]');
    if (q) {
      q.addEventListener('input', function () { var v = parseInt(q.value, 10); if (v >= 1) setQty(Math.min(MAX_QTY, v)); if (v > MAX_QTY) { S.quoteSheets = v; q.value = String(MAX_QTY); openQuote(); } });
      q.addEventListener('change', function () { setQty(q.value); });
      q.addEventListener('blur', function () { render(); });
    }
    on('[data-abb-qty-minus]', 'click', function () { setQty(cfg().qty - 1); });
    on('[data-abb-qty-plus]', 'click', function () { setQty(cfg().qty + 1); });
    // shirt preview: color, placement, 2D / 3D
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-adt-color], [data-adt-place], [data-adt-show], [data-adt-view]');
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-adt-color')) { S.shirt = b.getAttribute('data-adt-color'); syncShirt(true); return; }
      if (b.hasAttribute('data-adt-place')) { applyPlacement(b.getAttribute('data-adt-place')); return; }
      if (b.hasAttribute('data-adt-show')) { var w = b.getAttribute('data-adt-show'); if (w === '3d' && !startEngine()) return; S.show = w; syncShirt(true); if (eng) { try { eng.resize(); } catch (er) {} } return; }
      if (b.hasAttribute('data-adt-view')) { view3d(b.getAttribute('data-adt-view')); }
    });
    var sb = $('[data-adt-shirtbox]');
    if (sb && typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { syncShirt(); if (eng) { try { eng.resize(); } catch (e) {} } }).observe(sb); } catch (e) {} }
    bindLayout();
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    on('[data-abb-sig-text]', 'input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    on('[data-abb-approve-form]', 'submit', submitApproval);
    on('[data-abb-approve-form]', 'input', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-sig]', 'pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-approve-close]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve-back]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve]', 'cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }
  // the shared proof sheet (assets/ardor-proofsheet.js) puts its PDF button on the rail for the builders it knows;
  // this designer adds the same button itself and opens the same preview window
  function mountPdf(tries) {
    var PS = window.ArdorProofSheet, B = window.ArdorDtfBuilder, rail = $('.abx-rail');
    if (!PS || typeof PS.preview !== 'function' || !rail || !B || !B.proof) { if ((tries || 0) < 40) setTimeout(function () { mountPdf((tries || 0) + 1); }, 250); return; }
    if (B.proof._btn || $('[data-abb-pdf]', rail)) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'abx-tool'; btn.setAttribute('data-abb-pdf', ''); btn.title = 'Download a PDF proof preview';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 4v11m0 0 4.5-4.5M12 15l-4.5-4.5M4 19.5h16"/></svg><span>PDF</span>';
    var qb = $('[data-abx-quote]', rail);
    if (qb && qb.nextSibling) rail.insertBefore(btn, qb.nextSibling); else rail.appendChild(btn);
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (!objs().length) { showErr('Add a design first, then download your proof.'); return; } PS.preview(B.proof); });
    B.proof._btn = btn;
  }
  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  // ---------- AI designs (the AI drawer here and the AI t-shirt page): o = { blob, id, placement } ----------
  // The picture lands as one design at the placement's preset width (gang sheet: added next to the other designs);
  // a solid background is removed right away (the customer can Undo).
  function placeAi(o) {
    if (!o || !o.blob) return Promise.reject(new Error('no image'));
    var t = String(o.blob.type || ''), e2 = /png/.test(t) ? '.png' : (/webp/.test(t) ? '.webp' : '.jpg');
    var file = new File([o.blob], 'ardor-ai-tshirt-' + String(o.id || 'design').replace(/[^0-9a-z]/gi, '').slice(0, 8) + e2, { type: t || 'image/png' });
    var pl = String(o.placement || '').toLowerCase().replace(/[^a-z]/g, '');
    if (pl === 'chest' || pl === 'left') pl = 'leftchest';
    if (SH && pl) S.place = SH.placementOf(pl).id;
    if (!objs().length) S.mode = 'simple';
    var w = SH ? SH.placementOf(S.place).w : 11, C = window.ArdorDtfCutout;
    // the AI page's own cutout (assets/ardor-dtf-ai-cutout.js): the same trimmed, transparent art the customer saw there.
    // Big placements get it enlarged 3x (smooth edges; about 230 dpi at 11 in instead of about 78).
    var made = C && typeof C.cut === 'function' ? Promise.resolve(C.cut(o.blob, { holes: false, scale: w > 5 ? 3 : 1 })).then(function (r) {
      if (!r || !r.canvas) throw new Error('cutout');
      return entryFromCanvas(r.canvas, file, { ai: true, aiScale: w > 5 ? 3 : 1, plain: r.plain });
    }).catch(function () { return loadEntry(file, { ai: true }); }) : loadEntry(file, { ai: true });
    return made.then(function (en) {
      en.autoBg = true; en.aiId = o.id || '';
      return placeEntry(en, { place: S.place, w: w });
    }).then(function (ob) {
      track0('ardor_dtf_ai_design_loaded', { placement: S.place });
      return ob;
    });
  }
  // the center for a new w x h item (text, clipart): one design = under the design; gang sheet = the next free spot
  function newSpot(w, h) {
    var c = cfg();
    if (c.mode === 'simple') {
      var bb = masterBox();
      if (!bb) return { x: SHEET_W / 2, y: MARGIN + h / 2 };
      return { x: bb.x + bb.w / 2, y: bb.y + bb.h + GAP + h / 2 };
    }
    var p = E.freeSpot(objs().map(boxOf), Math.min(w, SHEET_W - 2 * MARGIN), h, c.len);
    var need = Math.ceil(p.y + h + MARGIN - 1e-6);
    if (need > S.len) { S.len = clamp(need, LMIN, LMAX); }
    return { x: p.x + Math.min(w, SHEET_W - 2 * MARGIN) / 2, y: p.y + h / 2 };
  }

  function init() {
    watchHeader();
    bind();
    render();
    window.ArdorDtfBuilder = {
      version: '1.0.0', state: S, live: function () { return LIVE; }, variants: function () { return VAR; }, loadMoreVariants: loadMoreVariants, cfg: cfg, price: price, render: render, variantFor: variantFor, centsFor: centsFor, fromCents: fromCents,
      imgs: IMGS, objects: objs, addFiles: addFiles, loadEntry: loadEntry, placeEntry: placeEntry, placeAi: placeAi, removeBg: removeBgFor, undoBg: undoBg,
      issues: function () { return allIssues(cfg()); }, pickMode: pickMode, setCopies: setCopies, setLen: setLen, setQty: setQty, fitSheet: fitSheet, arrange: arrangeAll,
      sizeDesign: sizeDesign, sizeObj: sizeObj, applyPlacement: applyPlacement, setZoom: setZoom, viewer: function () { return eng; }, startEngine: startEngine,
      sheetPicture: function (px) { return sheetPicture(cfg(), px || 1800, null); }, shirt: function (w, h) { var o = shirtOpts(); o.label = true; return SH ? SH.snapshot(w || 1000, h || 1030, o) : null; },
      proofBlob: function (approval) { return buildProof(cfg(), approval || null, approval ? 'final' : 'preview'); },
      printFiles: function (onProgress) { return printFiles(cfg(), onProgress); },
      spec: function () { var c = cfg(); return JSON.parse(specJson(c, price(c))); },
      // names for the template download (assets/ardor-dtf-tpl.js)
      tplInfo: function () { var c = cfg(); return { key: 'DTF-22x' + c.len, product: 'DTF Gang Sheet', size: sheetTxt(c.len), sizeName: sheetTxt(c.len), Wi: SHEET_W, Hi: c.len, margin: MARGIN, gap: GAP, ppi: PPI }; },
      layout: function () { return { zoom: lay.zoom, scale: lay.scale, ox: lay.ox, oy: lay.oy, cx: lay.cx, cy: lay.cy }; }
    };
    // used by ardor-dtf-layers.js (designs, text and clipart on the sheet). Sizes are in inches (c.Wi x c.Hi = 22 x L).
    window.ArdorDtfAPI = {
      cfg: cfg, conf: CONF, state: S, root: root, safe: MARGIN, set: set, render: render, toast: toast, noRescale: true,
      getArt: function () { return null; }, setArt: function () {}, editFace: function () { return 'front'; },
      renderArtOnly: renderArtOnly, layoutCanvas: function () { return lay.canvas; }, layoutScale: function () { return lay.scale; },
      // where the sheet sits on the 2D layout canvas (zoom and pan): z = css px per inch, ox / oy = sheet corner in css px
      layoutView: function () { return { z: lay.scale, ox: lay.ox, oy: lay.oy }; },
      faceBox: function () { var c = cfg(); return { x: 0, y: 0, w: c.Wi, h: c.Hi }; },
      safeBox: function () { var c = cfg(); return { x: MARGIN, y: MARGIN, w: c.Wi - 2 * MARGIN, h: c.Hi - 2 * MARGIN }; },
      newSpot: newSpot, textSize: function () { return 1.1; }, clipSize: function () { return 3; },
      onSelect: function () { renderObjPropsSoon(); syncShirt(); },
      entry: function (id) { return IMGS[id] || null; }, placeAi: placeAi, paintFace: function () { return false; },
      loadFile: function (f) { return addFiles([f]); }
    };
    window.ArdorDtfBuilder.proof = { noun: 'transfers', file: 'Ardor DTF Proof Preview', stamp: stampFile, make: function () { return buildProof(cfg(), null, 'preview'); } };
    try { document.dispatchEvent(new CustomEvent('ardor:dtf-api')); } catch (e) {}
    mountPdf(0);
    loadMoreVariants();
    var tg = $('[data-adt-show="3d"]'); if (tg) tg.hidden = !window.ArdorDtf3D;
    setTimeout(function () { var t2 = $('[data-adt-show="3d"]'); if (t2 && window.ArdorDtf3D && !engTried) t2.hidden = false; render(); }, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
